const Constants = {
  /*
  |  IsBusy
  */

  GLOBAL_IS_BUSY_POPUP_OPEN: "GLOBAL_IS_BUSY_POPUP_OPEN",
  GLOBAL_IS_BUSY_POPUP_CLOSE: "GLOBAL_IS_BUSY_POPUP_CLOSE",

  /*
  |  Socket
  */

  SOCKET_CONNECTED: "SOCKET_CONNECTED",
  SOCKET_DISCONNECTED: "SOCKET_DISCONNECTED",

  /*
  |  Loading Spinner
  */

  LOADING_SHOW: "LOADING_SHOW",
  LOADING_HIDE: "LOADING_HIDE",

  /*
  |  New Version
  */

  NEW_VERSION_AVAILABLE: "NEW_VERSION_AVAILABLE",
  NEW_VERSION_IGNORE: "NEW_VERSION_IGNORE",

  /*
  |  Versions Updates
  */

  GLOBAL_VERSIONS_UPDATE_LIST: "GLOBAL_VERSIONS_UPDATE_LIST",
  GLOBAL_VERSIONS_UPDATE_LIST_SUCCESS: "GLOBAL_VERSIONS_UPDATE_LIST_SUCCESS",

  /*
  |  Token
  */

  TOKEN_SUCCEEDED: "TOKEN_SUCCEEDED",
  TOKEN_UPDATE: "TOKEN_UPDATE",
  TOKEN_CHECK: "TOKEN_CHECK",
  TOKEN_ERR: "TOKEN_ERR",

  IS_TOKEN_USED_CHECK_START: "IS_TOKEN_USED_CHECK_START",
  IS_TOKEN_USED_CHECK_SUCCESS: "IS_TOKEN_USED_CHECK_SUCCESS",
  IS_TOKEN_USED_CHECK_FAILURE: "IS_TOKEN_USED_CHECK_FAILURE",

  /*
  |  Table Component
  */

  TABLE_COMPONENT_PAGINATOR_INCREASE: "TABLE_COMPONENT_PAGINATOR_INCREASE",

  /*
  |  Auth
  */

  AUTH_SIGNIN: "AUTH_SIGNIN",
  AUTH_SIGNOUT: "AUTH_SIGNOUT",
  GLOBAL_OPEN_NEW_AGENCY_COACH: "GLOBAL_OPEN_NEW_AGENCY_COACH",

  /*
  |  Snackbar
  */

  SNACKBAR_ADD_MESSAGE: "SNACKBAR_ADD_MESSAGE",
  SNACKBAR_REMOVE_MESSAGE: "SNACKBAR_REMOVE_MESSAGE",
  SNACKBAR_CLEAR_MESSAGES: "SNACKBAR_CLEAR_MESSAGES",

  /*
  |  Alert
  */

  ALERT_SHOW: "ALERT_SHOW",
  ALERT_HIDE: "ALERT_HIDE",

  /*
  |  Redirector
  */

  REDIRECTOR_ADD_PATHNAME: "REDIRECTOR_ADD_PATHNAME",

  /*
  |  Email Providers
  */

  GLOBAL_TYPES_LIST: "GLOBAL_TYPES_LIST",
  GLOBAL_TYPES_LIST_SUCCESS: "GLOBAL_TYPES_LIST_SUCCESS",
  PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_START: "PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_START",
  PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_REQUEST:
    "PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_REQUEST",
  PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_SUCCESS:
    "PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_SUCCESS",
  PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_FAILURE:
    "PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_FAILURE",
  PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_CLEAR: "PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_CLEAR",

  /*
  |  Contract statuses
  */

  GLOBAL_CONTRACT_STATUSES_LIST: "GLOBAL_CONTRACT_STATUSES_LIST",
  GLOBAL_CONTRACT_STATUSES_LIST_SUCCESS:
    "GLOBAL_CONTRACT_STATUSES_LIST_SUCCESS",

  /*
  |  Email Providers
  */

  PAGE_SETTINGS_EMAIL_ACCOUNT_INACTIVE_START:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_INACTIVE_START",

  /*
  |  Lookup searchtext
  */

  LOOKUP_SEARCHTEXT: "LOOKUP_SEARCHTEXT",
  LOOKUP_SEARCHTEXT_CLEAR: "LOOKUP_SEARCHTEXT_CLEAR",

  /*
  |  Subscriptions
  */

  GLOBAL_SUBSCRIPTION_LIST: "GLOBAL_SUBSCRIPTION_LIST",
  GLOBAL_SUBSCRIPTION_LIST_SUCCESS: "GLOBAL_SUBSCRIPTION_LIST_SUCCESS",

  GLOBAL_SUBSCRIPTION_CREATE_START: "GLOBAL_SUBSCRIPTION_CREATE_START",
  GLOBAL_SUBSCRIPTION_CREATE_REQUEST: "GLOBAL_SUBSCRIPTION_CREATE_REQUEST",
  GLOBAL_SUBSCRIPTION_CREATE_SUCCESS: "GLOBAL_SUBSCRIPTION_CREATE_SUCCESS",
  GLOBAL_SUBSCRIPTION_CREATE_FAILURE: "GLOBAL_SUBSCRIPTION_CREATE_FAILURE",

  GLOBAL_SUBSCRIPTION_DELETE_START: "GLOBAL_SUBSCRIPTION_DELETE_START",
  GLOBAL_SUBSCRIPTION_DELETE_REQUEST: "GLOBAL_SUBSCRIPTION_DELETE_REQUEST",
  GLOBAL_SUBSCRIPTION_DELETE_SUCCESS: "GLOBAL_SUBSCRIPTION_DELETE_SUCCESS",
  GLOBAL_SUBSCRIPTION_DELETE_FAILURE: "GLOBAL_SUBSCRIPTION_DELETE_FAILURE",

  /*
  |  Events
  */

  GLOBAL_EVENT_CREATE_START: "GLOBAL_EVENT_CREATE_START",
  GLOBAL_EVENT_CREATE_REQUEST: "GLOBAL_EVENT_CREATE_REQUEST",
  GLOBAL_EVENT_CREATE_SUCCESS: "GLOBAL_EVENT_CREATE_SUCCESS",
  GLOBAL_EVENT_CREATE_FAILURE: "GLOBAL_EVENT_CREATE_FAILURE",
  GLOBAL_EVENT_CREATE_CLEAR: "GLOBAL_EVENT_CREATE_CLEAR",

  GLOBAL_EVENT_UPDATE_START: "GLOBAL_EVENT_UPDATE_START",
  GLOBAL_EVENT_UPDATE_REQUEST: "GLOBAL_EVENT_UPDATE_REQUEST",
  GLOBAL_EVENT_UPDATE_SUCCESS: "GLOBAL_EVENT_UPDATE_SUCCESS",
  GLOBAL_EVENT_UPDATE_FAILURE: "GLOBAL_EVENT_UPDATE_FAILURE",
  GLOBAL_EVENT_UPDATE_CLEAR: "GLOBAL_EVENT_UPDATE_CLEAR",

  GLOBAL_EVENT_DELETE_START: "GLOBAL_EVENT_DELETE_START",
  GLOBAL_EVENT_DELETE_REQUEST: "GLOBAL_EVENT_DELETE_REQUEST",
  GLOBAL_EVENT_DELETE_SUCCESS: "GLOBAL_EVENT_DELETE_SUCCESS",
  GLOBAL_EVENT_DELETE_FAILURE: "GLOBAL_EVENT_DELETE_FAILURE",

  GLOBAL_EVENT_HIDE_START: "GLOBAL_EVENT_HIDE_START",
  GLOBAL_EVENT_HIDE_SUCCESS: "GLOBAL_EVENT_HIDE_SUCCESS",

  GLOBAL_EVENT_SNOOZE_START: "GLOBAL_EVENT_SNOOZE_START",
  GLOBAL_EVENT_SNOOZE_REQUEST: "GLOBAL_EVENT_SNOOZE_REQUEST",
  GLOBAL_EVENT_SNOOZE_SUCCESS: "GLOBAL_EVENT_SNOOZE_SUCCESS",
  GLOBAL_EVENT_SNOOZE_FAILURE: "GLOBAL_EVENT_SNOOZE_FAILURE",

  GLOBAL_EVENTS_SAVE_LIST: "GLOBAL_EVENTS_SAVE_LIST",
  GLOBAL_EVENTS_SAVE_LIST_SUCCESS: "GLOBAL_EVENTS_SAVE_LIST_SUCCESS",
  GLOBAL_EVENTS_SAVE_LIST_CLEAR: "GLOBAL_EVENTS_SAVE_LIST_CLEAR",
  GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS: "GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS",

  GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE: "GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE",

  GLOBAL_REMINDERS_SAVE_LIST: "GLOBAL_REMINDERS_SAVE_LIST",
  GLOBAL_REMINDERS_SAVE_LIST_SUCCESS: "GLOBAL_REMINDERS_SAVE_LIST_SUCCESS",

  GLOBAL_NOTIFICATIONS_COUNT: "GLOBAL_NOTIFICATIONS_COUNT",
  GLOBAL_NOTIFICATIONS_COUNT_SUCCESS: "GLOBAL_NOTIFICATIONS_COUNT_SUCCESS",

  GLOBAL_ACTIVITIES_COUNT: "GLOBAL_ACTIVITIES_COUNT",
  GLOBAL_ACTIVITIES_COUNT_SUCCESS: "GLOBAL_ACTIVITIES_COUNT_SUCCESS",

  /*
  |  Event Update
  */

  PAGE_EVENT_UPDATE_START: "PAGE_EVENT_UPDATE_START",
  PAGE_EVENT_UPDATE_REQUEST: "PAGE_EVENT_UPDATE_REQUEST",
  PAGE_EVENT_UPDATE_SUCCESS: "PAGE_EVENT_UPDATE_SUCCESS",
  PAGE_EVENT_UPDATE_FAILURE: "PAGE_EVENT_UPDATE_FAILURE",
  PAGE_EVENT_UPDATE_CLEAR: "PAGE_EVENT_UPDATE_CLEAR",

  /*
  |  Agency
  */

  GLOBAL_AGENCY_LIST: "GLOBAL_AGENCY_LIST",
  GLOBAL_AGENCY_LIST_SUCCESS: "GLOBAL_AGENCY_LIST_SUCCESS",
  GLOBAL_GET_AGENCY_LIST: "GLOBAL_GET_AGENCY_LIST",
  GLOBAL_GET_AGENCY_LIST_SUCCESS: "GLOBAL_GET_AGENCY_LIST_SUCCESS",

  GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START:
    "GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START",
  GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_REQUEST:
    "GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_REQUEST",
  GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_SUCCESS:
    "GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_SUCCESS",
  GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE:
    "GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE",

  GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START:
    "GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START",
  GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_REQUEST:
    "GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_REQUEST",
  GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_SUCCESS:
    "GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_SUCCESS",
  GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE:
    "GLOBAL_UNDO_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE",

  GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_START:
    "GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_START",
  GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_REQUEST:
    "GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_REQUEST",
  GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_SUCCESS:
    "GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_SUCCESS",
  GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_FAILURE:
    "GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_FAILURE",
  GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_CLEAR_ERROR:
    "GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_CLEAR_ERROR",

  GLOBAL_UNDO_DEPOSIT_FROM_SAVINGS_ACCOUNT_START:
    "GLOBAL_UNDO_DEPOSIT_FROM_SAVINGS_ACCOUNT_START",    

  SAVINGS_FILTER_SEARCH_UPDATE_STATE: "SAVINGS_FILTER_SEARCH_UPDATE_STATE",

  /*
  |  Email Accounts
  */

  GLOBAL_EMAIL_ACCOUNT_LIST: "GLOBAL_EMAIL_ACCOUNT_LIST",
  GLOBAL_EMAIL_ACCOUNT_LIST_SUCCESS: "GLOBAL_EMAIL_ACCOUNT_LIST_SUCCESS",

  /*
  |  Bank Transactions
  */

  GLOBAL_TRANSACTION_FILE_LIST: "GLOBAL_TRANSACTION_FILE_LIST",
  GLOBAL_TRANSACTION_FILE_LIST_SUCCESS: "GLOBAL_TRANSACTION_FILE_LIST_SUCCESS",

  GLOBAL_TRANSACTION_FILE_UPLOAD_START: "GLOBAL_TRANSACTION_FILE_UPLOAD_START",
  GLOBAL_TRANSACTION_FILE_UPLOAD_REQUEST:
    "GLOBAL_TRANSACTION_FILE_UPLOAD_REQUEST",
  GLOBAL_TRANSACTION_FILE_UPLOAD_SUCCESS:
    "GLOBAL_TRANSACTION_FILE_UPLOAD_SUCCESS",
  GLOBAL_TRANSACTION_FILE_UPLOAD_FAILURE:
    "GLOBAL_TRANSACTION_FILE_UPLOAD_FAILURE",

  GLOBAL_TRANSACTION_FILE_CREATE_START: "GLOBAL_TRANSACTION_FILE_CREATE_START",
  GLOBAL_TRANSACTION_FILE_CREATE_REQUEST:
    "GLOBAL_TRANSACTION_FILE_CREATE_REQUEST",
  GLOBAL_TRANSACTION_FILE_CREATE_SUCCESS:
    "GLOBAL_TRANSACTION_FILE_CREATE_SUCCESS",
  GLOBAL_TRANSACTION_FILE_CREATE_FAILURE:
    "GLOBAL_TRANSACTION_FILE_CREATE_FAILURE",

  GLOBAL_TRANSACTION_FILE_UPDATE_START: "GLOBAL_TRANSACTION_FILE_UPDATE_START",
  GLOBAL_TRANSACTION_FILE_UPDATE_REQUEST:
    "GLOBAL_TRANSACTION_FILE_UPDATE_REQUEST",
  GLOBAL_TRANSACTION_FILE_UPDATE_SUCCESS:
    "GLOBAL_TRANSACTION_FILE_UPDATE_SUCCESS",
  GLOBAL_TRANSACTION_FILE_UPDATE_FAILURE:
    "GLOBAL_TRANSACTION_FILE_UPDATE_FAILURE",

  GLOBAL_TRANSACTION_FILE_DELETE_START: "GLOBAL_TRANSACTION_FILE_DELETE_START",
  GLOBAL_TRANSACTION_FILE_DELETE_REQUEST:
    "GLOBAL_TRANSACTION_FILE_DELETE_REQUEST",
  GLOBAL_TRANSACTION_FILE_DELETE_SUCCESS:
    "GLOBAL_TRANSACTION_FILE_DELETE_SUCCESS",
  GLOBAL_TRANSACTION_FILE_DELETE_FAILURE:
    "GLOBAL_TRANSACTION_FILE_DELETE_FAILURE",

  GLOBAL_TRANSACTION_FILE_DATA_START: "GLOBAL_TRANSACTION_FILE_DATA_START",
  GLOBAL_TRANSACTION_FILE_DATA_REQUEST: "GLOBAL_TRANSACTION_FILE_DATA_REQUEST",
  GLOBAL_TRANSACTION_FILE_DATA_SUCCESS: "GLOBAL_TRANSACTION_FILE_DATA_SUCCESS",
  GLOBAL_TRANSACTION_FILE_DATA_FAILURE: "GLOBAL_TRANSACTION_FILE_DATA_FAILURE",

  GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_START:
    "GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_START",
  GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_REQUEST:
    "GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_REQUEST",
  GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_SUCCESS:
    "GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_SUCCESS",
  GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_FAILURE:
    "GLOBAL_TRANSACTION_FILE_PAYMENT_SET_PROCESSED_FAILURE",

  GLOBAL_PAYMENT_SET_PROCESSED_START: "GLOBAL_PAYMENT_SET_PROCESSED_START",
  GLOBAL_PAYMENT_SET_PROCESSED_REQUEST: "GLOBAL_PAYMENT_SET_PROCESSED_REQUEST",
  GLOBAL_PAYMENT_SET_PROCESSED_SUCCESS: "GLOBAL_PAYMENT_SET_PROCESSED_SUCCESS",
  GLOBAL_PAYMENT_SET_PROCESSED_FAILURE: "GLOBAL_PAYMENT_SET_PROCESSED_FAILURE",

  PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE:
    "PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE",

  /*
  |  Balance
  */

  BALANCE_FETCH: "BALANCE_FETCH",

  /*
  |  Dashboard
  */

  DASHBOARD_FETCH: "DASHBOARD_FETCH",
  DASHBOARD_FETCH_SUCCESS: "DASHBOARD_FETCH_SUCCESS",
  PAGE_DASHBOARD_UPDATE_SWITCH_TAB: "PAGE_DASHBOARD_UPDATE_SWITCH_TAB",
  PAGE_STATEMENT_LIST_CHECK_FILTER: "PAGE_STATEMENT_LIST_CHECK_FILTER",
  GLOBAL_SAVE_UNPAID_RECEIVABLE_CHARGES_COUNT:
    "GLOBAL_SAVE_UNPAID_RECEIVABLE_CHARGES_COUNT",
  GLOBAL_SAVE_UNPAID_PAYABLE_CHARGES_COUNT:
    "GLOBAL_SAVE_UNPAID_PAYABLE_CHARGES_COUNT",
  GLOBAL_SAVE_UNUSED_PAYMENTS_COUNT: "GLOBAL_SAVE_UNUSED_PAYMENTS_COUNT",
  GLOBAL_SAVE_NOTSENT_STATEMENTS_COUNT: "GLOBAL_SAVE_NOTSENT_STATEMENTS_COUNT",
  GLOBAL_SAVE_NOTFINISHED_TASKS_COUNT: "GLOBAL_SAVE_NOTFINISHED_TASKS_COUNT",
  DASHBOARD_STATEMENTS_LIST_POSITION_SAVE:
    "DASHBOARD_STATEMENTS_LIST_POSITION_SAVE",

  /*
  |  Attachments
  */

  GLOBAL_ATTACHMENT_DELETE_START: "GLOBAL_ATTACHMENT_DELETE_START",
  GLOBAL_ATTACHMENT_DELETE_REQUEST: "GLOBAL_ATTACHMENT_DELETE_REQUEST",
  GLOBAL_ATTACHMENT_PERSON_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_PERSON_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_AGENCY_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_AGENCY_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_COMPANY_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_COMPANY_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_PROPERTY_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_PROPERTY_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_UNIT_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_UNIT_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_CONTRACT_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_CONTRACT_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_TASK_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_TASK_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_CHARGE_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_CHARGE_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_EVENT_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_EVENT_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_CONVERSATION_DELETE_SUCCESS:
    "GLOBAL_ATTACHMENT_CONVERSATION_DELETE_SUCCESS",
  GLOBAL_ATTACHMENT_DELETE_FAILURE: "GLOBAL_ATTACHMENT_DELETE_FAILURE",

  GLOBAL_SET_AVATAR_START: "GLOBAL_SET_AVATAR_START",
  GLOBAL_SET_AVATAR_REQUEST: "GLOBAL_SET_AVATAR_REQUEST",
  GLOBAL_SET_AVATAR_SUCCESS: "GLOBAL_SET_AVATAR_SUCCESS",
  GLOBAL_SET_AVATAR_FAILURE: "GLOBAL_SET_AVATAR_FAILURE",

  GLOBAL_ATTACHMENT_UPLOAD_START: "GLOBAL_ATTACHMENT_UPLOAD_START",
  GLOBAL_ATTACHMENT_UPLOAD_REQUEST: "GLOBAL_ATTACHMENT_UPLOAD_REQUEST",
  GLOBAL_ATTACHMENT_PERSON_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_PERSON_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_AGENCY_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_AGENCY_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_COMPANY_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_COMPANY_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_PROPERTY_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_PROPERTY_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_UNIT_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_UNIT_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_CONTRACT_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_CONTRACT_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_TASK_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_TASK_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_CHARGE_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_CHARGE_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_EVENT_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_EVENT_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_CONVERSATION_UPLOAD_SUCCESS:
    "GLOBAL_ATTACHMENT_CONVERSATION_UPLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_UPLOAD_FAILURE: "GLOBAL_ATTACHMENT_UPLOAD_FAILURE",
  GLOBAL_ATTACHMENT_UPLOAD_SUCCESS: "GLOBAL_ATTACHMENT_UPLOAD_SUCCESS",

  GLOBAL_ATTACHMENT_LIST: "GLOBAL_ATTACHMENT_LIST",
  GLOBAL_ATTACHMENT_LIST_SUCCESS: "GLOBAL_ATTACHMENT_LIST_SUCCESS",

  GLOBAL_ATTACHMENT_DOWNLOAD_START: "GLOBAL_ATTACHMENT_DOWNLOAD_START",
  GLOBAL_ATTACHMENT_DOWNLOAD_REQUEST: "GLOBAL_ATTACHMENT_DOWNLOAD_REQUEST",
  GLOBAL_ATTACHMENT_DOWNLOAD_SUCCESS: "GLOBAL_ATTACHMENT_DOWNLOAD_SUCCESS",
  GLOBAL_ATTACHMENT_DOWNLOAD_FAILURE: "GLOBAL_ATTACHMENT_DOWNLOAD_FAILURE",

  /*
  |  Companies
  */

  GLOBAL_COMPANY_LIST: "GLOBAL_COMPANY_LIST",
  GLOBAL_COMPANY_LIST_SUCCESS: "GLOBAL_COMPANY_LIST_SUCCESS",

  GLOBAL_COMPANY_DELETE_START: "GLOBAL_COMPANY_DELETE_START",
  GLOBAL_COMPANY_DELETE_REQUEST: "GLOBAL_COMPANY_DELETE_REQUEST",
  GLOBAL_COMPANY_DELETE_SUCCESS: "GLOBAL_COMPANY_DELETE_SUCCESS",
  GLOBAL_COMPANY_DELETE_FAILURE: "GLOBAL_COMPANY_DELETE_FAILURE",

  GLOBAL_COMPANY_ADD_PERSON: "GLOBAL_COMPANY_ADD_PERSON",
  GLOBAL_COMPANY_ADD_PERSON_AFTER_CREATING:
    "GLOBAL_COMPANY_ADD_PERSON_AFTER_CREATING",

  GLOBAL_COMPANY_UNLINK_PERSON_START: "GLOBAL_COMPANY_UNLINK_PERSON_START",
  GLOBAL_COMPANY_UNLINK_PERSON_REQUEST: "GLOBAL_COMPANY_UNLINK_PERSON_REQUEST",
  GLOBAL_COMPANY_UNLINK_PERSON_SUCCESS: "GLOBAL_COMPANY_UNLINK_PERSON_SUCCESS",
  GLOBAL_COMPANY_UNLINK_PERSON_FAILURE: "GLOBAL_COMPANY_UNLINK_PERSON_FAILURE",

  GLOBAL_COMPANY_FOR_COMPANY_DETAILS_PAGE:
    "GLOBAL_COMPANY_FOR_COMPANY_DETAILS_PAGE",

  /*
  |  Persons
  */

  GLOBAL_PERSON_LIST: "GLOBAL_PERSON_LIST",
  GLOBAL_PERSON_LIST_SUCCESS: "GLOBAL_PERSON_LIST_SUCCESS",

  GLOBAL_PERSON_DELETE_START: "GLOBAL_PERSON_DELETE_START",
  GLOBAL_PERSON_DELETE_REQUEST: "GLOBAL_PERSON_DELETE_REQUEST",
  GLOBAL_PERSON_DELETE_SUCCESS: "GLOBAL_PERSON_DELETE_SUCCESS",
  GLOBAL_PERSON_DELETE_FAILURE: "GLOBAL_PERSON_DELETE_FAILURE",

  GLOBAL_PERSON_FOR_PERSON_DETAILS_PAGE:
    "GLOBAL_PERSON_FOR_PERSON_DETAILS_PAGE",

  /*
  |  Properties
  */

  GLOBAL_PROPERTY_LIST: "GLOBAL_PROPERTY_LIST",
  GLOBAL_PROPERTY_LIST_SUCCESS: "GLOBAL_PROPERTY_LIST_SUCCESS",

  PAGE_PROPERTY_UPDATE_SWITCH_TAB: "PAGE_PROPERTY_UPDATE_SWITCH_TAB",

  GLOBAL_PROPERTY_FOR_PROPERTY_DETAILS_PAGE:
    "GLOBAL_PROPERTY_FOR_PROPERTY_DETAILS_PAGE",

  /*
  |  Units
  */

  GLOBAL_UNIT_LIST: "GLOBAL_UNIT_LIST",
  GLOBAL_UNIT_LIST_SUCCESS: "GLOBAL_UNIT_LIST_SUCCESS",

  GLOBAL_UNIT_CREATE_START: "GLOBAL_UNIT_CREATE_START",
  GLOBAL_UNIT_CREATE_REQUEST: "GLOBAL_UNIT_CREATE_REQUEST",
  GLOBAL_UNIT_CREATE_SUCCESS: "GLOBAL_UNIT_CREATE_SUCCESS",
  GLOBAL_UNIT_CREATE_FAILURE: "GLOBAL_UNIT_CREATE_FAILURE",
  GLOBAL_UNIT_CREATE_CLEAR: "GLOBAL_UNIT_CREATE_CLEAR",

  GLOBAL_UNIT_UPDATE_START: "GLOBAL_UNIT_UPDATE_START",
  GLOBAL_UNIT_UPDATE_REQUEST: "GLOBAL_UNIT_UPDATE_REQUEST",
  GLOBAL_UNIT_UPDATE_SUCCESS: "GLOBAL_UNIT_UPDATE_SUCCESS",
  GLOBAL_UNIT_UPDATE_FAILURE: "GLOBAL_UNIT_UPDATE_FAILURE",
  GLOBAL_UNIT_UPDATE_CLEAR: "GLOBAL_UNIT_UPDATE_CLEAR",

  GLOBAL_UNIT_DELETE_START: "GLOBAL_UNIT_DELETE_START",
  GLOBAL_UNIT_DELETE_REQUEST: "GLOBAL_UNIT_DELETE_REQUEST",
  GLOBAL_UNIT_DELETE_SUCCESS: "GLOBAL_UNIT_DELETE_SUCCESS",
  GLOBAL_UNIT_DELETE_FAILURE: "GLOBAL_UNIT_DELETE_FAILURE",

  GLOBAL_UNIT_SET_ACTIVE_START: "GLOBAL_UNIT_SET_ACTIVE_START",
  GLOBAL_UNIT_SET_ACTIVE_REQUEST: "GLOBAL_UNIT_SET_ACTIVE_REQUEST",
  GLOBAL_UNIT_SET_ACTIVE_SUCCESS: "GLOBAL_UNIT_SET_ACTIVE_SUCCESS",
  GLOBAL_UNIT_SET_ACTIVE_FAILURE: "GLOBAL_UNIT_SET_ACTIVE_FAILURE",


  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_START: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_START",
  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_REQUEST: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_REQUEST",
  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_SUCCESS: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_SUCCESS",
  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_FAILURE: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_PERCENT_FAILURE",

  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_START: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_START",
  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_REQUEST: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_REQUEST",
  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_SUCCESS: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_SUCCESS",
  GLOBAL_UNIT_CHANGE_SERVICE_STATUS_FAILURE: "GLOBAL_UNIT_CHANGE_SERVICE_STATUS_FAILURE",
  PAGE_UNIT_UPDATE_SWITCH_TAB: "PAGE_UNIT_UPDATE_SWITCH_TAB",

  GLOBAL_UNIT_FOR_UNIT_DETAILS_PAGE: "GLOBAL_UNIT_FOR_UNIT_DETAILS_PAGE",

  /*
  |  Contracts
  */

  GLOBAL_CONTRACT_LIST: "GLOBAL_CONTRACT_LIST",
  GLOBAL_CONTRACT_LIST_SUCCESS: "GLOBAL_CONTRACT_LIST_SUCCESS",

  GLOBAL_CONTRACT_CREATE_START: "GLOBAL_CONTRACT_CREATE_START",
  GLOBAL_CONTRACT_CREATE_REQUEST: "GLOBAL_CONTRACT_CREATE_REQUEST",
  GLOBAL_CONTRACT_CREATE_SUCCESS: "GLOBAL_CONTRACT_CREATE_SUCCESS",
  GLOBAL_CONTRACT_CREATE_FAILURE: "GLOBAL_CONTRACT_CREATE_FAILURE",
  GLOBAL_CONTRACT_CREATE_CLEAR: "GLOBAL_CONTRACT_CREATE_CLEAR",
  GLOBAL_CONTRACT_CREATE_ERRORS_CLEAR: "GLOBAL_CONTRACT_CREATE_ERRORS_CLEAR",

  GLOBAL_CONTRACT_EXTEND_START: "GLOBAL_CONTRACT_EXTEND_START",
  GLOBAL_CONTRACT_EXTEND_REQUEST: "GLOBAL_CONTRACT_EXTEND_REQUEST",
  GLOBAL_CONTRACT_EXTEND_SUCCESS: "GLOBAL_CONTRACT_EXTEND_SUCCESS",
  GLOBAL_CONTRACT_EXTEND_FAILURE: "GLOBAL_CONTRACT_EXTEND_FAILURE",
  GLOBAL_CONTRACT_EXTEND_CLEAR: "GLOBAL_CONTRACT_EXTEND_CLEAR",
  GLOBAL_CONTRACT_EXTEND_ERRORS_CLEAR: "GLOBAL_CONTRACT_EXTEND_ERRORS_CLEAR",

  PAGE_CONTRACT_EXTEND_PUT_CHARGE_TEMPLATES_TO_MEMORY:
    "PAGE_CONTRACT_EXTEND_PUT_CHARGE_TEMPLATES_TO_MEMORY",

  GLOBAL_CONTRACT_DELETE_START: "GLOBAL_CONTRACT_DELETE_START",
  GLOBAL_CONTRACT_DELETE_REQUEST: "GLOBAL_CONTRACT_DELETE_REQUEST",
  GLOBAL_CONTRACT_DELETE_SUCCESS: "GLOBAL_CONTRACT_DELETE_SUCCESS",
  GLOBAL_CONTRACT_DELETE_FAILURE: "GLOBAL_CONTRACT_DELETE_FAILURE",

  PAGE_CONTRACT_UPDATE_SWITCH_TAB: "PAGE_CONTRACT_UPDATE_SWITCH_TAB",

  GLOBAL_CONTRACT_FOR_CONTRACT_DETAILS_PAGE:
    "GLOBAL_CONTRACT_FOR_CONTRACT_DETAILS_PAGE",

  CONTRACTS_FILTER_UPDATE_STATE: "CONTRACTS_FILTER_UPDATE_STATE",
  CONTRACTS_FILTER_SEARCH_UPDATE_STATE: "CONTRACTS_FILTER_SEARCH_UPDATE_STATE",

  CONTACTS_FILTER_UPDATE_STATE: "CONTACTS_FILTER_UPDATE_STATE",
  CONTACTS_FILTER_SEARCH_UPDATE_STATE: "CONTACTS_FILTER_SEARCH_UPDATE_STATE",

  COMPANIES_FILTER_UPDATE_STATE: "COMPANIES_FILTER_UPDATE_STATE",
  COMPANIES_FILTER_SEARCH_UPDATE_STATE: "COMPANIES_FILTER_SEARCH_UPDATE_STATE",

  GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_START:
    "GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_START",
  GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_REQUEST:
    "GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_REQUEST",
  GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_SUCCESS:
    "GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_SUCCESS",
  GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_FAILURE:
    "GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_FAILURE",

  PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_START:
    "PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_START",
  PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_REQUEST:
    "PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_REQUEST",
  PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_SUCCESS:
    "PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_SUCCESS",
  PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_FAILURE:
    "PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_FAILURE",

  GLOBAL_CONTRACT_END_START: "GLOBAL_CONTRACT_END_START",
  GLOBAL_CONTRACT_END_REQUEST: "GLOBAL_CONTRACT_END_REQUEST",
  GLOBAL_CONTRACT_END_SUCCESS: "GLOBAL_CONTRACT_END_SUCCESS",
  GLOBAL_CONTRACT_END_FAILURE: "GLOBAL_CONTRACT_END_FAILURE",

  GLOBAL_CONTRACT_EXPIRATION_START: "GLOBAL_CONTRACT_EXPIRATION_START",
  GLOBAL_CONTRACT_EXPIRATION_REQUEST: "GLOBAL_CONTRACT_EXPIRATION_REQUEST",
  GLOBAL_CONTRACT_EXPIRATION_SUCCESS: "GLOBAL_CONTRACT_EXPIRATION_SUCCESS",
  GLOBAL_CONTRACT_EXPIRATION_FAILURE: "GLOBAL_CONTRACT_EXPIRATION_FAILURE",

  GLOBAL_CONTRACT_SIGN_START: "GLOBAL_CONTRACT_SIGN_START",
  GLOBAL_CONTRACT_SIGN_REQUEST: "GLOBAL_CONTRACT_SIGN_REQUEST",
  GLOBAL_CONTRACT_SIGN_SUCCESS: "GLOBAL_CONTRACT_SIGN_SUCCESS",
  GLOBAL_CONTRACT_SIGN_FAILURE: "GLOBAL_CONTRACT_SIGN_FAILURE",

  GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_START:
    "GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_START",
  GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_REQUEST:
    "GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_REQUEST",
  GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_SUCCESS:
    "GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_SUCCESS",
  GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_FAILURE:
    "GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_FAILURE",

  /*
  |  Charge Templates
  */

  GLOBAL_CHARGE_TEMPLATE_LIST: "GLOBAL_CHARGE_TEMPLATE_LIST",
  GLOBAL_CHARGE_TEMPLATE_LIST_SUCCESS: "GLOBAL_CHARGE_TEMPLATE_LIST_SUCCESS",

  GLOBAL_CHARGE_TEMPLATE_CREATE_START: "GLOBAL_CHARGE_TEMPLATE_CREATE_START",
  GLOBAL_CHARGE_TEMPLATE_CREATE_REQUEST:
    "GLOBAL_CHARGE_TEMPLATE_CREATE_REQUEST",
  GLOBAL_CHARGE_TEMPLATE_CREATE_SUCCESS:
    "GLOBAL_CHARGE_TEMPLATE_CREATE_SUCCESS",
  GLOBAL_CHARGE_TEMPLATE_CREATE_FAILURE:
    "GLOBAL_CHARGE_TEMPLATE_CREATE_FAILURE",
  GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR: "GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR",

  GLOBAL_CHARGE_TEMPLATE_UPDATE_START: "GLOBAL_CHARGE_TEMPLATE_UPDATE_START",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_REQUEST:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_REQUEST",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_SUCCESS:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_SUCCESS",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR: "GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR",

  GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_START:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_START",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_REQUEST:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_REQUEST",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_SUCCESS:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_SUCCESS",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_FAILURE:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_FAILURE",
  GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_CLEAR:
    "GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_CLEAR",

  GLOBAL_CHARGE_TEMPLATE_DELETE_START: "GLOBAL_CHARGE_TEMPLATE_DELETE_START",
  GLOBAL_CHARGE_TEMPLATE_DELETE_REQUEST:
    "GLOBAL_CHARGE_TEMPLATE_DELETE_REQUEST",
  GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS:
    "GLOBAL_CHARGE_TEMPLATE_DELETE_SUCCESS",
  GLOBAL_CHARGE_TEMPLATE_DELETE_FAILURE:
    "GLOBAL_CHARGE_TEMPLATE_DELETE_FAILURE",

  /*
  |  Agency Fee
  */

  GLOBAL_AGENCY_FEE_LIST: "GLOBAL_AGENCY_FEE_LIST",
  GLOBAL_AGENCY_FEE_LIST_SUCCESS: "GLOBAL_AGENCY_FEE_LIST_SUCCESS",

  GLOBAL_AGENCY_FEE_CREATE_START: "GLOBAL_AGENCY_FEE_CREATE_START",
  GLOBAL_AGENCY_FEE_CREATE_DEFAULT_START:
    "GLOBAL_AGENCY_FEE_CREATE_DEFAULT_START",
  GLOBAL_AGENCY_FEE_CREATE_REQUEST: "GLOBAL_AGENCY_FEE_CREATE_REQUEST",
  GLOBAL_AGENCY_FEE_CREATE_SUCCESS: "GLOBAL_AGENCY_FEE_CREATE_SUCCESS",
  GLOBAL_AGENCY_FEE_CREATE_FAILURE: "GLOBAL_AGENCY_FEE_CREATE_FAILURE",
  GLOBAL_AGENCY_FEE_CREATE_CLEAR: "GLOBAL_AGENCY_FEE_CREATE_CLEAR",

  GLOBAL_AGENCY_FEE_UPDATE_START: "GLOBAL_AGENCY_FEE_UPDATE_START",
  GLOBAL_AGENCY_FEE_UPDATE_DEFAULT_START:
    "GLOBAL_AGENCY_FEE_UPDATE_DEFAULT_START",
  GLOBAL_AGENCY_FEE_UPDATE_REQUEST: "GLOBAL_AGENCY_FEE_UPDATE_REQUEST",
  GLOBAL_AGENCY_FEE_UPDATE_SUCCESS: "GLOBAL_AGENCY_FEE_UPDATE_SUCCESS",
  GLOBAL_AGENCY_FEE_UPDATE_FAILURE: "GLOBAL_AGENCY_FEE_UPDATE_FAILURE",
  GLOBAL_AGENCY_FEE_UPDATE_CLEAR: "GLOBAL_AGENCY_FEE_UPDATE_CLEAR",

  GLOBAL_AGENCY_FEE_DELETE_START: "GLOBAL_AGENCY_FEE_DELETE_START",
  GLOBAL_AGENCY_FEE_DELETE_REQUEST: "GLOBAL_AGENCY_FEE_DELETE_REQUEST",
  GLOBAL_AGENCY_FEE_DELETE_SUCCESS: "GLOBAL_AGENCY_FEE_DELETE_SUCCESS",
  GLOBAL_AGENCY_FEE_DELETE_FAILURE: "GLOBAL_AGENCY_FEE_DELETE_FAILURE",

  GLOBAL_AGENCY_FEE_SIGN_START: "GLOBAL_AGENCY_FEE_SIGN_START",
  GLOBAL_AGENCY_FEE_SIGN_REQUEST: "GLOBAL_AGENCY_FEE_SIGN_REQUEST",
  GLOBAL_AGENCY_FEE_SIGN_SUCCESS: "GLOBAL_AGENCY_FEE_SIGN_SUCCESS",
  GLOBAL_AGENCY_FEE_SIGN_FAILURE: "GLOBAL_AGENCY_FEE_SIGN_FAILURE",
  GLOBAL_AGENCY_FEE_SIGN_CLEAR: "GLOBAL_AGENCY_FEE_SIGN_CLEAR",

  GLOBAL_AGENCY_FEE_END_START: "GLOBAL_AGENCY_FEE_END_START",
  GLOBAL_AGENCY_FEE_END_REQUEST: "GLOBAL_AGENCY_FEE_END_REQUEST",
  GLOBAL_AGENCY_FEE_END_SUCCESS: "GLOBAL_AGENCY_FEE_END_SUCCESS",
  GLOBAL_AGENCY_FEE_END_FAILURE: "GLOBAL_AGENCY_FEE_END_FAILURE",
  GLOBAL_AGENCY_FEE_END_CLEAR: "GLOBAL_AGENCY_FEE_END_CLEAR",

  /*
  |  Address
  */

  GLOBAL_ADDRESS_LIST: "GLOBAL_ADDRESS_LIST",
  GLOBAL_ADDRESS_LIST_SUCCESS: "GLOBAL_ADDRESS_LIST_SUCCESS",

  GLOBAL_ADDRESS_CREATE_START: "GLOBAL_ADDRESS_CREATE_START",
  GLOBAL_ADDRESS_CREATE_REQUEST: "GLOBAL_ADDRESS_CREATE_REQUEST",
  GLOBAL_ADDRESS_CREATE_SUCCESS: "GLOBAL_ADDRESS_CREATE_SUCCESS",
  GLOBAL_ADDRESS_CREATE_FAILURE: "GLOBAL_ADDRESS_CREATE_FAILURE",
  GLOBAL_ADDRESS_CREATE_CLEAR: "GLOBAL_ADDRESS_CREATE_CLEAR",

  GLOBAL_ADDRESS_UPDATE_START: "GLOBAL_ADDRESS_UPDATE_START",
  GLOBAL_ADDRESS_UPDATE_REQUEST: "GLOBAL_ADDRESS_UPDATE_REQUEST",
  GLOBAL_ADDRESS_UPDATE_SUCCESS: "GLOBAL_ADDRESS_UPDATE_SUCCESS",
  GLOBAL_ADDRESS_UPDATE_FAILURE: "GLOBAL_ADDRESS_UPDATE_FAILURE",
  GLOBAL_ADDRESS_UPDATE_CLEAR: "GLOBAL_ADDRESS_UPDATE_CLEAR",

  GLOBAL_ADDRESS_DELETE_START: "GLOBAL_ADDRESS_DELETE_START",
  GLOBAL_ADDRESS_DELETE_REQUEST: "GLOBAL_ADDRESS_DELETE_REQUEST",
  GLOBAL_ADDRESS_DELETE_SUCCESS: "GLOBAL_ADDRESS_DELETE_SUCCESS",
  GLOBAL_ADDRESS_DELETE_FAILURE: "GLOBAL_ADDRESS_DELETE_FAILURE",

  /*
  |  Charges
  */
  GLOBAL_CHARGES_SAVE_LIST: "GLOBAL_CHARGES_SAVE_LIST",
  GLOBAL_CHARGES_SAVE_LIST_SUCCESS: "GLOBAL_CHARGES_SAVE_LIST_SUCCESS",
  GLOBAL_CHARGES_SAVE_LIST_CLEAR: "GLOBAL_CHARGES_SAVE_LIST_CLEAR",
  GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS: "GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS",

  GLOBAL_CHARGES_NOT_SAVE_LIST: "GLOBAL_CHARGES_NOT_SAVE_LIST",

  GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE:
    "GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE",

  GLOBAL_CHARGE_DETAILS_FROM_LAST_SIMILAR_PAYMENT:
    "GLOBAL_CHARGE_DETAILS_FROM_LAST_SIMILAR_PAYMENT",

  GLOBAL_GET_MATCHED_CHARGES_LIST: "GLOBAL_GET_MATCHED_CHARGES_LIST",
  GLOBAL_GET_MATCHED_PAYMENTS_LIST: "GLOBAL_GET_MATCHED_PAYMENTS_LIST",

  GLOBAL_CHARGE_CREATE_START: "GLOBAL_CHARGE_CREATE_START",
  GLOBAL_CHARGE_CREATE_REQUEST: "GLOBAL_CHARGE_CREATE_REQUEST",
  GLOBAL_CHARGE_CREATE_SUCCESS: "GLOBAL_CHARGE_CREATE_SUCCESS",
  GLOBAL_CHARGE_CREATE_FAILURE: "GLOBAL_CHARGE_CREATE_FAILURE",
  GLOBAL_CHARGE_CREATE_CLEAR: "GLOBAL_CHARGE_CREATE_CLEAR",

  GLOBAL_CHARGE_UPDATE_START: "GLOBAL_CHARGE_UPDATE_START",
  GLOBAL_CHARGE_UPDATE_REQUEST: "GLOBAL_CHARGE_UPDATE_REQUEST",
  GLOBAL_CHARGE_UPDATE_SUCCESS: "GLOBAL_CHARGE_UPDATE_SUCCESS",
  GLOBAL_CHARGE_UPDATE_FAILURE: "GLOBAL_CHARGE_UPDATE_FAILURE",
  GLOBAL_CHARGE_UPDATE_CLEAR: "GLOBAL_CHARGE_UPDATE_CLEAR",

  GLOBAL_CHARGE_LINK_START: "GLOBAL_CHARGE_LINK_START",
  GLOBAL_CHARGE_LINK_REQUEST: "GLOBAL_CHARGE_LINK_REQUEST",
  GLOBAL_CHARGE_LINK_SUCCESS: "GLOBAL_CHARGE_LINK_SUCCESS",
  GLOBAL_CHARGE_LINK_FAILURE: "GLOBAL_CHARGE_LINK_FAILURE",

  GLOBAL_CHARGE_UNLINK_START: "GLOBAL_CHARGE_UNLINK_START",
  GLOBAL_CHARGE_UNLINK_REQUEST: "GLOBAL_CHARGE_UNLINK_REQUEST",
  GLOBAL_CHARGE_UNLINK_SUCCESS: "GLOBAL_CHARGE_UNLINK_SUCCESS",
  GLOBAL_CHARGE_UNLINK_FAILURE: "GLOBAL_CHARGE_UNLINK_FAILURE",

  GLOBAL_CHARGE_DELETE_START: "GLOBAL_CHARGE_DELETE_START",
  GLOBAL_CHARGE_DELETE_REQUEST: "GLOBAL_CHARGE_DELETE_REQUEST",
  GLOBAL_CHARGE_DELETE_SUCCESS: "GLOBAL_CHARGE_DELETE_SUCCESS",
  GLOBAL_CHARGE_DELETE_FAILURE: "GLOBAL_CHARGE_DELETE_FAILURE",

  GLOBAL_CHARGE_SETTLE_START: "GLOBAL_CHARGE_SETTLE_START",
  GLOBAL_CHARGE_SETTLE_REQUEST: "GLOBAL_CHARGE_SETTLE_REQUEST",
  GLOBAL_CHARGE_SETTLE_SUCCESS: "GLOBAL_CHARGE_SETTLE_SUCCESS",
  GLOBAL_CHARGE_SETTLE_FAILURE: "GLOBAL_CHARGE_SETTLE_FAILURE",
  GLOBAL_CHARGE_SETTLE_CLEAR: "GLOBAL_CHARGE_SETTLE_CLEAR",

  GLOBAL_CHARGE_TYPE_CREATE_START: "GLOBAL_CHARGE_TYPE_CREATE_START",
  GLOBAL_CHARGE_TYPE_CREATE_REQUEST: "GLOBAL_CHARGE_TYPE_CREATE_REQUEST",
  GLOBAL_CHARGE_TYPE_CREATE_FAILURE: "GLOBAL_CHARGE_TYPE_CREATE_FAILURE",
  GLOBAL_CHARGE_TYPE_CREATE_SUCCESS: "GLOBAL_CHARGE_TYPE_CREATE_SUCCESS",
  GLOBAL_CHARGE_TYPE_CREATE_CLEAR: "GLOBAL_CHARGE_TYPE_CREATE_CLEAR",

  GLOBAL_CHARGE_TYPE_UPDATE_START: "GLOBAL_CHARGE_TYPE_UPDATE_START",
  GLOBAL_CHARGE_TYPE_UPDATE_REQUEST: "GLOBAL_CHARGE_TYPE_UPDATE_REQUEST",
  GLOBAL_CHARGE_TYPE_UPDATE_FAILURE: "GLOBAL_CHARGE_TYPE_UPDATE_FAILURE",
  GLOBAL_CHARGE_TYPE_UPDATE_SUCCESS: "GLOBAL_CHARGE_TYPE_UPDATE_SUCCESS",
  GLOBAL_CHARGE_TYPE_UPDATE_CLEAR: "GLOBAL_CHARGE_TYPE_UPDATE_CLEAR",

  GLOBAL_CHARGE_TYPE_DELETE_START: "GLOBAL_CHARGE_TYPE_DELETE_START",
  GLOBAL_CHARGE_TYPE_DELETE_REQUEST: "GLOBAL_CHARGE_TYPE_DELETE_REQUEST",
  GLOBAL_CHARGE_TYPE_DELETE_FAILURE: "GLOBAL_CHARGE_TYPE_DELETE_FAILURE",
  GLOBAL_CHARGE_TYPE_DELETE_SUCCESS: "GLOBAL_CHARGE_TYPE_DELETE_SUCCESS",

  GLOBAL_CHARGE_UNSETTLE_START: "GLOBAL_CHARGE_UNSETTLE_START",
  GLOBAL_CHARGE_UNSETTLE_REQUEST: "GLOBAL_CHARGE_UNSETTLE_REQUEST",
  GLOBAL_CHARGE_UNSETTLE_FAILURE: "GLOBAL_CHARGE_UNSETTLE_FAILURE",
  GLOBAL_CHARGE_UNSETTLE_SUCCESS: "GLOBAL_CHARGE_UNSETTLE_SUCCESS",

  FINANCE_CHARGES_FILTER_UPDATE_STATE: "FINANCE_CHARGES_FILTER_UPDATE_STATE",
  FINANCE_CHARGES_FILTER_DATE_UPDATE_STATE:
    "FINANCE_CHARGES_FILTER_DATE_UPDATE_STATE",
  FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE:
    "FINANCE_CHARGES_FILTER_SEARCH_UPDATE_STATE",
  FINANCE_CHARGES_LIST_POSITION_SAVE: "FINANCE_CHARGES_LIST_POSITION_SAVE",
  DASHBOARD_CHARGES_LIST_POSITION_SAVE: "DASHBOARD_CHARGES_LIST_POSITION_SAVE",
  FINANCE_CHARGES_LIST_CHECK_FILTER: "FINANCE_CHARGES_LIST_CHECK_FILTER",
  DASHBOARD_PAYABLES_UPDATE_FILTERS_STATE:
    "DASHBOARD_PAYABLES_UPDATE_FILTERS_STATE",
  DASHBOARD_RECEIVABLES_UPDATE_FILTERS_STATE:
    "DASHBOARD_RECEIVABLES_UPDATE_FILTERS_STATE",

  GLOBAL_CHARGE_SEND_START: "GLOBAL_CHARGE_SEND_START",
  GLOBAL_CHARGE_SEND_REQUEST: "GLOBAL_CHARGE_SEND_REQUEST",
  GLOBAL_CHARGE_SEND_SUCCESS: "GLOBAL_CHARGE_SEND_SUCCESS",
  GLOBAL_CHARGE_SEND_FAILURE: "GLOBAL_CHARGE_SEND_FAILURE",
  GLOBAL_CHARGE_SEND_CLEAR: "GLOBAL_CHARGE_SEND_CLEAR",

  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_START:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_START",
  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_REQUEST:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_REQUEST",
  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_SUCCESS:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_SUCCESS",
  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_FAILURE:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_FAILURE",

  GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_START:
    "GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_START",
  GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_REQUEST:
    "GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_REQUEST",
  GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_SUCCESS:
    "GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_SUCCESS",
  GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_FAILURE:
    "GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_FAILURE",

  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_START:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_START",
  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_REQUEST:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_REQUEST",
  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_SUCCESS:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_SUCCESS",
  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_FAILURE:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_FAILURE",

  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START",
  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_REQUEST:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_REQUEST",
  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_SUCCESS:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_SUCCESS",
  GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_FAILURE:
    "GLOBAL_SETTLE_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_FAILURE",

  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_START",
  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_REQUEST:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_REQUEST",
  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_SUCCESS:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_SUCCESS",
  GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_FAILURE:
    "GLOBAL_SETTLE_PAYMENT_WITH_SAVINGS_ACCOUNT_CHECK_SCENARIO_FAILURE",

  CHARGE_DETAILS_UPDATE_ACTION: "CHARGE_DETAILS_UPDATE_ACTION",
  GLOBAL_CHARGE_PERIOD: "GLOBAL_CHARGE_PERIOD",

  GLOBAL_CHARGE_SNOOZE_UPDATE_START: "GLOBAL_CHARGE_SNOOZE_UPDATE_START",
  GLOBAL_CHARGE_SNOOZE_UPDATE_REQUEST: "GLOBAL_CHARGE_SNOOZE_UPDATE_REQUEST",
  GLOBAL_CHARGE_SNOOZE_UPDATE_SUCCESS: "GLOBAL_CHARGE_SNOOZE_UPDATE_SUCCESS",
  GLOBAL_CHARGE_SNOOZE_UPDATE_FAILURE: "GLOBAL_CHARGE_SNOOZE_UPDATE_FAILURE",

  GLOBAL_CHARGE_UNREFUND_START: "GLOBAL_CHARGE_UNREFUND_START",
  GLOBAL_CHARGE_UNREFUND_REQUEST: "GLOBAL_CHARGE_UNREFUND_REQUEST",
  GLOBAL_CHARGE_UNREFUND_SUCCESS: "GLOBAL_CHARGE_UNREFUND_SUCCESS",
  GLOBAL_CHARGE_UNREFUND_FAILURE: "GLOBAL_CHARGE_UNREFUND_FAILURE",
  GLOBAL_CHARGE_UNREFUND_CLEAR: "GLOBAL_CHARGE_UNREFUND_CLEAR",

  GLOBAL_CHARGE_UNDO_CREDIT_START: "GLOBAL_CHARGE_UNDO_CREDIT_START",
  GLOBAL_CHARGE_UNDO_CREDIT_REQUEST: "GLOBAL_CHARGE_UNDO_CREDIT_REQUEST",
  GLOBAL_CHARGE_UNDO_CREDIT_SUCCESS: "GLOBAL_CHARGE_UNDO_CREDIT_SUCCESS",
  GLOBAL_CHARGE_UNDO_CREDIT_FAILURE: "GLOBAL_CHARGE_UNDO_CREDIT_FAILURE",
  GLOBAL_CHARGE_UNDO_CREDIT_CLEAR: "GLOBAL_CHARGE_UNDO_CREDIT_CLEAR",

  GLOBAL_CHARGE_CHANGE_SENT_START: "GLOBAL_CHARGE_CHANGE_SENT_START",
  GLOBAL_CHARGE_CHANGE_SENT_REQUEST: "GLOBAL_CHARGE_CHANGE_SENT_REQUEST",
  GLOBAL_CHARGE_CHANGE_SENT_SUCCESS: "GLOBAL_CHARGE_CHANGE_SENT_SUCCESS",
  GLOBAL_CHARGE_CHANGE_SENT_FAILURE: "GLOBAL_CHARGE_CHANGE_SENT_FAILURE",

  GLOBAL_CHARGE_CREATE_INVOICE_START: "GLOBAL_CHARGE_CREATE_INVOICE_START",
  GLOBAL_CHARGE_CREATE_INVOICE_REQUEST: "GLOBAL_CHARGE_CREATE_INVOICE_REQUEST",
  GLOBAL_CHARGE_CREATE_INVOICE_SUCCESS: "GLOBAL_CHARGE_CREATE_INVOICE_SUCCESS",
  GLOBAL_CHARGE_CREATE_INVOICE_FAILURE: "GLOBAL_CHARGE_CREATE_INVOICE_FAILURE",

  GLOBAL_CHARGE_CREATE_CREDIT_START: "GLOBAL_CHARGE_CREATE_CREDIT_START",
  GLOBAL_CHARGE_CREATE_CREDIT_REQUEST: "GLOBAL_CHARGE_CREATE_CREDIT_REQUEST",
  GLOBAL_CHARGE_CREATE_CREDIT_SUCCESS: "GLOBAL_CHARGE_CREATE_CREDIT_SUCCESS",
  GLOBAL_CHARGE_CREATE_CREDIT_FAILURE: "GLOBAL_CHARGE_CREATE_CREDIT_FAILURE",

  GLOBAL_CHARGE_PAID_TO_OWNER_START: "GLOBAL_CHARGE_PAID_TO_OWNER_START",
  GLOBAL_CHARGE_PAID_TO_OWNER_REQUEST: "GLOBAL_CHARGE_PAID_TO_OWNER_REQUEST",
  GLOBAL_CHARGE_PAID_TO_OWNER_SUCCESS: "GLOBAL_CHARGE_PAID_TO_OWNER_SUCCESS",
  GLOBAL_CHARGE_PAID_TO_OWNER_FAILURE: "GLOBAL_CHARGE_PAID_TO_OWNER_FAILURE",

  GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_START:
    "GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_START",
  GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_REQUEST:
    "GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_REQUEST",
  GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_SUCCESS:
    "GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_SUCCESS",
  GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_FAILURE:
    "GLOBAL_UNDO_CHARGE_PAID_TO_OWNER_FAILURE",

  /*
  |  Bill process
  */

  BILL_SETTLEMENT_PROCESS_CLEAR:'BILL_SETTLEMENT_PROCESS_CLEAR',
  BILL_SETTLEMENT_PROCESS_REQUEST:'BILL_SETTLEMENT_PROCESS_REQUEST',
  BILL_SETTLEMENT_PROCESS_SUCCESS:'BILL_SETTLEMENT_PROCESS_SUCCESS',
  BILL_SETTLEMENT_PROCESS_OUTDATE_REQUESTS:'BILL_SETTLEMENT_PROCESS_OUTDATE_REQUESTS',
  BILL_SETTLEMENT_PROCESS_FAILURE:'BILL_SETTLEMENT_PROCESS_FAILURE',
  BILL_SETTLEMENT_PROCESS_START:'BILL_SETTLEMENT_PROCESS_START',

  /*
  |  Payments
  */
  GLOBAL_PAYMENTS_SAVE_LIST: "GLOBAL_PAYMENTS_SAVE_LIST",
  GLOBAL_PAYMENTS_SAVE_LIST_SUCCESS: "GLOBAL_PAYMENTS_SAVE_LIST_SUCCESS",
  GLOBAL_PAYMENTS_SAVE_LIST_CLEAR: "GLOBAL_PAYMENTS_SAVE_LIST_CLEAR",
  GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS:
    "GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS",

  GLOBAL_PAYMENTS_NOT_SAVE_LIST: "GLOBAL_PAYMENTS_NOT_SAVE_LIST",

  GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE:
    "GLOBAL_PAYMENT_FOR_PAYMENT_DETAILS_PAGE",

  GLOBAL_PAYMENT_CREATE_START: "GLOBAL_PAYMENT_CREATE_START",
  GLOBAL_PAYMENT_CREATE_REQUEST: "GLOBAL_PAYMENT_CREATE_REQUEST",
  GLOBAL_PAYMENT_CREATE_SUCCESS: "GLOBAL_PAYMENT_CREATE_SUCCESS",
  GLOBAL_PAYMENT_CREATE_FAILURE: "GLOBAL_PAYMENT_CREATE_FAILURE",
  GLOBAL_PAYMENT_CREATE_CLEAR: "GLOBAL_PAYMENT_CREATE_CLEAR",

  GLOBAL_PAYMENT_CREATE_AND_LINK_START: "GLOBAL_PAYMENT_CREATE_AND_LINK_START",
  GLOBAL_PAYMENT_CREATE_AND_LINK_REQUEST:
    "GLOBAL_PAYMENT_CREATE_AND_LINK_REQUEST",
  GLOBAL_PAYMENT_CREATE_AND_LINK_SUCCESS:
    "GLOBAL_PAYMENT_CREATE_AND_LINK_SUCCESS",
  GLOBAL_PAYMENT_CREATE_AND_LINK_FAILURE:
    "GLOBAL_PAYMENT_CREATE_AND_LINK_FAILURE",
  GLOBAL_PAYMENT_CREATE_AND_LINK_CLEAR: "GLOBAL_PAYMENT_CREATE_AND_LINK_CLEAR",

  GLOBAL_PAYMENT_UPDATE_START: "GLOBAL_PAYMENT_UPDATE_START",
  GLOBAL_PAYMENT_UPDATE_REQUEST: "GLOBAL_PAYMENT_UPDATE_REQUEST",
  GLOBAL_PAYMENT_UPDATE_SUCCESS: "GLOBAL_PAYMENT_UPDATE_SUCCESS",
  GLOBAL_PAYMENT_UPDATE_FAILURE: "GLOBAL_PAYMENT_UPDATE_FAILURE",
  GLOBAL_PAYMENT_UPDATE_CLEAR: "GLOBAL_PAYMENT_UPDATE_CLEAR",

  GLOBAL_PAYMENT_UPDATE_FIELD_START: "GLOBAL_PAYMENT_UPDATE_FIELD_START",
  GLOBAL_PAYMENT_UPDATE_FIELD_REQUEST: "GLOBAL_PAYMENT_UPDATE_FIELD_REQUEST",
  GLOBAL_PAYMENT_UPDATE_FIELD_SUCCESS: "GLOBAL_PAYMENT_UPDATE_FIELD_SUCCESS",
  GLOBAL_PAYMENT_UPDATE_FIELD_FAILURE: "GLOBAL_PAYMENT_UPDATE_FIELD_FAILURE",
  GLOBAL_PAYMENT_UPDATE_FIELD_CLEAR: "GLOBAL_PAYMENT_UPDATE_FIELD_CLEAR",

  GLOBAL_PAYMENT_LINK_START: "GLOBAL_PAYMENT_LINK_START",
  GLOBAL_PAYMENT_LINK_REQUEST: "GLOBAL_PAYMENT_LINK_REQUEST",
  GLOBAL_PAYMENT_LINK_SUCCESS: "GLOBAL_PAYMENT_LINK_SUCCESS",
  GLOBAL_PAYMENT_LINK_FAILURE: "GLOBAL_PAYMENT_LINK_FAILURE",
  GLOBAL_PAYMENT_LINK_CLEAR: "GLOBAL_PAYMENT_LINK_CLEAR",

  GLOBAL_PAYMENT_UNLINK_START: "GLOBAL_PAYMENT_UNLINK_START",
  GLOBAL_PAYMENT_UNLINK_REQUEST: "GLOBAL_PAYMENT_UNLINK_REQUEST",
  GLOBAL_PAYMENT_UNLINK_SUCCESS: "GLOBAL_PAYMENT_UNLINK_SUCCESS",
  GLOBAL_PAYMENT_UNLINK_FAILURE: "GLOBAL_PAYMENT_UNLINK_FAILURE",

  GLOBAL_PAYMENT_DELETE_START: "GLOBAL_PAYMENT_DELETE_START",
  GLOBAL_PAYMENT_DELETE_REQUEST: "GLOBAL_PAYMENT_DELETE_REQUEST",
  GLOBAL_PAYMENT_DELETE_SUCCESS: "GLOBAL_PAYMENT_DELETE_SUCCESS",
  GLOBAL_PAYMENT_DELETE_FAILURE: "GLOBAL_PAYMENT_DELETE_FAILURE",

  GLOBAL_PAYMENT_SETTLE_START: "GLOBAL_PAYMENT_SETTLE_START",
  GLOBAL_PAYMENT_SETTLE_REQUEST: "GLOBAL_PAYMENT_SETTLE_REQUEST",
  GLOBAL_PAYMENT_SETTLE_SUCCESS: "GLOBAL_PAYMENT_SETTLE_SUCCESS",
  GLOBAL_PAYMENT_SETTLE_FAILURE: "GLOBAL_PAYMENT_SETTLE_FAILURE",
  GLOBAL_PAYMENT_SETTLE_CLEAR: "GLOBAL_PAYMENT_SETTLE_CLEAR",

  GLOBAL_PAYMENT_UNSETTLE_START: "GLOBAL_PAYMENT_UNSETTLE_START",
  GLOBAL_PAYMENT_UNSETTLE_REQUEST: "GLOBAL_PAYMENT_UNSETTLE_REQUEST",
  GLOBAL_PAYMENT_UNSETTLE_SUCCESS: "GLOBAL_PAYMENT_UNSETTLE_SUCCESS",
  GLOBAL_PAYMENT_UNSETTLE_FAILURE: "GLOBAL_PAYMENT_UNSETTLE_FAILURE",

  FINANCE_PAYMENTS_FILTER_BANK_ACCOUNT_UPDATE_STATE:
    "FINANCE_PAYMENTS_FILTER_BANK_ACCOUNT_UPDATE_STATE",
  FINANCE_PAYMENTS_FILTER_UPDATE_STATE: "FINANCE_PAYMENTS_FILTER_UPDATE_STATE",
  FINANCE_PAYMENTS_FILTER_DATE_UPDATE_STATE:
    "FINANCE_PAYMENTS_FILTER_DATE_UPDATE_STATE",
  FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE:
    "FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE",
  SAVINGS_PAYMENTS_FILTER_SEARCH_UPDATE_STATE:
    "SAVINGS_PAYMENTS_FILTER_SEARCH_UPDATE_STATE",
  FINANCE_PAYMENTS_LIST_POSITION_SAVE: "FINANCE_PAYMENTS_LIST_POSITION_SAVE",
  DASHBOARD_PAYMENTS_LIST_POSITION_SAVE:
    "DASHBOARD_PAYMENTS_LIST_POSITION_SAVE",
  SAVINGS_PAYMENTS_LIST_POSITION_SAVE: "SAVINGS_PAYMENTS_LIST_POSITION_SAVE",
  TRANSACTION_FILTER_UPDATE_STATE: "TRANSACTION_FILTER_UPDATE_STATE",
  DASHBOARD_PAYMENTS_LIST_CHECK_FILTER: "DASHBOARD_PAYMENTS_LIST_CHECK_FILTER",

  FINANCE_BANK_TRANSACTIONS_FILTER_UPDATE_STATE:
    "FINANCE_BANK_TRANSACTIONS_FILTER_UPDATE_STATE",
  FINANCE_BANK_TRANSACTIONS_LIST_POSITION_SAVE:
    "FINANCE_BANK_TRANSACTIONS_LIST_POSITION_SAVE",

  GLOBAL_PAYMENT_CONSIDER_INCOME_FOR_AGENCY_START:
    "GLOBAL_PAYMENT_CONSIDER_INCOME_FOR_AGENCY_START",
  GLOBAL_PAYMENT_CONSIDER_INCOME_FOR_AGENCY_FAILURE:
    "GLOBAL_PAYMENT_CONSIDER_INCOME_FOR_AGENCY_FAILURE",

  GLOBAL_PAYMENT_SNOOZE_UPDATE_START: "GLOBAL_PAYMENT_SNOOZE_UPDATE_START",
  GLOBAL_PAYMENT_SNOOZE_UPDATE_REQUEST: "GLOBAL_PAYMENT_SNOOZE_UPDATE_REQUEST",
  GLOBAL_PAYMENT_SNOOZE_UPDATE_SUCCESS: "GLOBAL_PAYMENT_SNOOZE_UPDATE_SUCCESS",
  GLOBAL_PAYMENT_SNOOZE_UPDATE_FAILURE: "GLOBAL_PAYMENT_SNOOZE_UPDATE_FAILURE",

  GLOBAL_PAYMENT_REFUND_START: "GLOBAL_PAYMENT_REFUND_START",
  GLOBAL_PAYMENT_REFUND_REQUEST: "GLOBAL_PAYMENT_REFUND_REQUEST",
  GLOBAL_PAYMENT_REFUND_SUCCESS: "GLOBAL_PAYMENT_REFUND_SUCCESS",
  GLOBAL_PAYMENT_REFUND_FAILURE: "GLOBAL_PAYMENT_REFUND_FAILURE",
  GLOBAL_PAYMENT_REFUND_CLEAR: "GLOBAL_PAYMENT_REFUND_CLEAR",
  GLOBAL_PAYMENT_REFUND_CHECK_START: "GLOBAL_PAYMENT_REFUND_CHECK_START",

  GLOBAL_PAYMENT_COSTS_START: "GLOBAL_PAYMENT_COSTS_START",
  GLOBAL_PAYMENT_COSTS_REQUEST: "GLOBAL_PAYMENT_COSTS_REQUEST",
  GLOBAL_PAYMENT_COSTS_SUCCESS: "GLOBAL_PAYMENT_COSTS_SUCCESS",
  GLOBAL_PAYMENT_COSTS_FAILURE: "GLOBAL_PAYMENT_COSTS_FAILURE",
  GLOBAL_PAYMENT_COSTS_CLEAR: "GLOBAL_PAYMENT_COSTS_CLEAR",

  OPEN_PAYMENT_CARD_ON_DETAILED_VIEW: "OPEN_PAYMENT_CARD_ON_DETAILED_VIEW",
  RESET_PAYMENT_CARD_ON_DETAILED_VIEW: "RESET_PAYMENT_CARD_ON_DETAILED_VIEW",

  /*
  |  Settings
  */

  PAGE_SETTINGS_UPDATE_SWITCH_TAB: "PAGE_SETTINGS_UPDATE_SWITCH_TAB",
  PAGE_SETTINGS_UPDATE_AGENCY_CATEGORY: "PAGE_SETTINGS_UPDATE_AGENCY_CATEGORY",

  // User Profile
  PAGE_SETTINGS_USER_PROFILE_UPDATE_START:
    "PAGE_SETTINGS_USER_PROFILE_UPDATE_START",
  PAGE_SETTINGS_USER_PROFILE_UPDATE_REQUEST:
    "PAGE_SETTINGS_USER_PROFILE_UPDATE_REQUEST",
  PAGE_SETTINGS_USER_PROFILE_UPDATE_SUCCESS:
    "PAGE_SETTINGS_USER_PROFILE_UPDATE_SUCCESS",
  PAGE_SETTINGS_USER_PROFILE_UPDATE_FAILURE:
    "PAGE_SETTINGS_USER_PROFILE_UPDATE_FAILURE",

  PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_START:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_START",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_REQUEST:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_REQUEST",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_SUCCESS:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_SUCCESS",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_FAILURE:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_PASSWORD_FAILURE",

  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_START:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_START",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_REQUEST:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_REQUEST",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_SUCCESS:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_SUCCESS",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_FAILURE:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_FAILURE",

  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_START:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_START",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_REQUEST:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_REQUEST",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_SUCCESS:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_SUCCESS",
  PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_FAILURE:
    "PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_FAILURE",

  PAGE_SETTINGS_USER_PROFILE_CLEAR: "PAGE_SETTINGS_USER_PROFILE_CLEAR",

  // Agency Profile

  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_START: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_START",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_REQUEST: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_REQUEST",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SUCCESS: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SUCCESS",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_FAILURE: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_FAILURE",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_CLEAR: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_CLEAR",

  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_START: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_START",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_REQUEST: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_REQUEST",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_SUCCESS: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_SUCCESS",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_FAILURE: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_FAILURE",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_CLEAR: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_ADMIN_FEE_CLEAR",

  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_START",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_REQUEST: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_REQUEST",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_SUCCESS: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_SUCCESS",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_FAILURE: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_FAILURE",
  PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_CLEAR: "PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_SETTINGS_CLEAR",

  PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_START: "PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_START",
  PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_REQUEST: "PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_REQUEST",
  PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_SUCCESS: "PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_SUCCESS",
  PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_FAILURE: "PAGE_SETTINGS_AGENCY_PROFILE_FINANCIAL_START_DATE_UPDATE_FAILURE",

  PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_START: "PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_START",
  PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_REQUEST: "PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_REQUEST",
  PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_SUCCESS: "PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_SUCCESS",
  PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_FAILURE: "PAGE_SETTINGS_AGENCY_PROFILE_INVOICE_NUMBER_ACTIVATION_DATE_UPDATE_FAILURE",

  PAGE_SETTINGS_AGENCY_PROFILE_CLEAR: "PAGE_SETTINGS_AGENCY_PROFILE_CLEAR",

  // Preferences
  PAGE_SETTINGS_PREFERENCES_UPDATE_START:
    "PAGE_SETTINGS_PREFERENCES_UPDATE_START",
  PAGE_SETTINGS_PREFERENCES_UPDATE_REQUEST:
    "PAGE_SETTINGS_PREFERENCES_UPDATE_REQUEST",
  PAGE_SETTINGS_PREFERENCES_UPDATE_SUCCESS:
    "PAGE_SETTINGS_PREFERENCES_UPDATE_SUCCESS",
  PAGE_SETTINGS_PREFERENCES_UPDATE_FAILURE:
    "PAGE_SETTINGS_PREFERENCES_UPDATE_FAILURE",
  PAGE_SETTINGS_PREFERENCES_UPDATE_CLEAR:
    "PAGE_SETTINGS_PREFERENCES_UPDATE_CLEAR",

  // Email Accounts
  PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_START:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_START",
  PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_REQUEST:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_REQUEST",
  PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_SUCCESS:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_SUCCESS",
  PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_FAILURE:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_FAILURE",
  PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_CLEAR:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_CLEAR",

  PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_START:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_START",
  PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_REQUEST:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_REQUEST",
  PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_SUCCESS:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_SUCCESS",
  PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_FAILURE:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_FAILURE",
  PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_CLEAR:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_CLEAR",

  PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_START:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_START",
  PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_REQUEST:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_REQUEST",
  PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_SUCCESS:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_SUCCESS",
  PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_FAILURE:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_FAILURE",

  PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG",
  PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_UPDATING:
    "PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_UPDATING",
  PAGE_SETTINGS_EMAIL_ACCOUNT_CLEAR: "PAGE_SETTINGS_EMAIL_ACCOUNT_CLEAR",

  /*
  |  Signup
  */

  PAGE_SIGNUP_UPDATE_EMAIL: "PAGE_SIGNUP_UPDATE_EMAIL",
  PAGE_SIGNUP_UPDATE_COMPANY: "PAGE_SIGNUP_UPDATE_COMPANY",
  PAGE_SIGNUP_UPDATE_CONTACT: "PAGE_SIGNUP_UPDATE_CONTACT",
  PAGE_SIGNUP_START: "PAGE_SIGNUP_START",
  PAGE_SIGNUP_REQUEST: "PAGE_SIGNUP_REQUEST",
  PAGE_SIGNUP_SUCCESS: "PAGE_SIGNUP_SUCCESS",
  PAGE_SIGNUP_FAILURE: "PAGE_SIGNUP_FAILURE",
  PAGE_SIGNUP_CLEAR: "PAGE_SIGNUP_CLEAR",
  POST_PROCESS_SIGN_UP_MESSAGE: "POST_PROCESS_SIGN_UP_MESSAGE",
  POST_PROCESS_SIGN_UP_MESSAGE_CLEAR: "POST_PROCESS_SIGN_UP_MESSAGE_CLEAR",

  /*
  |  Check Email
  */

  PAGE_CHECK_EMAIL_UPDATE_EMAIL: "PAGE_CHECK_EMAIL_UPDATE_EMAIL",
  PAGE_CHECK_EMAIL_UPDATE_COMPANY: "PAGE_CHECK_EMAIL_UPDATE_COMPANY",
  PAGE_CHECK_EMAIL_UPDATE_CONTACT: "PAGE_CHECK_EMAIL_UPDATE_CONTACT",
  PAGE_CHECK_EMAIL_START: "PAGE_CHECK_EMAIL_START",
  PAGE_CHECK_EMAIL_REQUEST: "PAGE_CHECK_EMAIL_REQUEST",
  PAGE_CHECK_EMAIL_SUCCESS: "PAGE_CHECK_EMAIL_SUCCESS",
  PAGE_CHECK_EMAIL_FAILURE: "PAGE_CHECK_EMAIL_FAILURE",
  PAGE_CHECK_EMAIL_CLEAR: "PAGE_CHECK_EMAIL_CLEAR",
  PAGE_CHECK_EMAIL_ADD_SIGNOUT_REASON: "PAGE_CHECK_EMAIL_ADD_SIGNOUT_REASON",

  /*
  |  Check Version
  */

  PAGE_CHECK_VERSION_START: "PAGE_CHECK_VERSION_START",
  PAGE_CHECK_VERSION: "PAGE_CHECK_VERSION",
  PAGE_CHECK_VERSION_SUCCESS: "PAGE_CHECK_VERSION_SUCCESS",
  PAGE_CHECK_VERSION_FAILURE: "PAGE_CHECK_VERSION_FAILURE",

  /*
  |  Forgot Password
  */

  PAGE_FORGOT_PASSWORD_REQUEST: "PAGE_FORGOT_PASSWORD_REQUEST",
  PAGE_FORGOT_PASSWORD_SUCCESS: "PAGE_FORGOT_PASSWORD_SUCCESS",
  PAGE_FORGOT_PASSWORD_FAILURE: "PAGE_FORGOT_PASSWORD_FAILURE",
  PAGE_FORGOT_PASSWORD_OPEN_POPUP: "PAGE_FORGOT_PASSWORD_OPEN_POPUP",
  PAGE_FORGOT_PASSWORD_CLOSE_POPUP: "PAGE_FORGOT_PASSWORD_CLOSE_POPUP",

  /*
  |  Signout
  */

  PAGE_SIGNOUT_START: "PAGE_SIGNOUT_START",
  PAGE_SIGNOUT_REQUEST: "PAGE_SIGNOUT_REQUEST",
  PAGE_SIGNOUT_SUCCESS: "PAGE_SIGNOUT_SUCCESS",
  PAGE_SIGNOUT_FAILURE: "PAGE_SIGNOUT_FAILURE",

  /*
  |  Confirm
  */

  PAGE_CONFIRM_FORGOT_PASSWORD_REQUEST: "PAGE_CONFIRM_FORGOT_PASSWORD_REQUEST",
  PAGE_CONFIRM_FORGOT_PASSWORD_SUCCESS: "PAGE_CONFIRM_FORGOT_PASSWORD_SUCCESS",
  PAGE_CONFIRM_FORGOT_PASSWORD_FAILURE: "PAGE_CONFIRM_FORGOT_PASSWORD_FAILURE",

  PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_REQUEST:
    "PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_REQUEST",
  PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_SUCCESS:
    "PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_SUCCESS",
  PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_FAILURE:
    "PAGE_CONFIRM_RESEND_CONFIRMATION_EMAIL_FAILURE",

  PAGE_CONFIRM_CONFIRM_ACCOUNT_REQUEST: "PAGE_CONFIRM_CONFIRM_ACCOUNT_REQUEST",
  PAGE_CONFIRM_CONFIRM_ACCOUNT_SUCCESS: "PAGE_CONFIRM_CONFIRM_ACCOUNT_SUCCESS",
  PAGE_CONFIRM_CONFIRM_ACCOUNT_FAILURE: "PAGE_CONFIRM_CONFIRM_ACCOUNT_FAILURE",

  PAGE_CONFIRM_RESET_PASSWORD_REQUEST: "PAGE_CONFIRM_RESET_PASSWORD_REQUEST",
  PAGE_CONFIRM_RESET_PASSWORD_SUCCESS: "PAGE_CONFIRM_RESET_PASSWORD_SUCCESS",
  PAGE_CONFIRM_RESET_PASSWORD_FAILURE: "PAGE_CONFIRM_RESET_PASSWORD_FAILURE",

  PAGE_CONFIRM_SIGNIN: "PAGE_CONFIRM_SIGNIN",
  PAGE_CONFIRM_SIGNIN_SUCCESS: "PAGE_CONFIRM_SIGNIN_SUCCESS",
  PAGE_CONFIRM_SIGNIN_FAILURE: "PAGE_CONFIRM_SIGNIN_FAILURE",

  PAGE_CONFIRM_UPDATE_PASSWORD: "PAGE_CONFIRM_UPDATE_PASSWORD",
  PAGE_CONFIRM_UPDATE_CONFIRM_PASSWORD: "PAGE_CONFIRM_UPDATE_CONFIRM_PASSWORD",

  PAGE_CONFIRM_CLOSE_POPUP_START: "PAGE_CONFIRM_CLOSE_POPUP_START",
  PAGE_CONFIRM_CLOSE_POPUP: "PAGE_CONFIRM_CLOSE_POPUP",
  PAGE_CONFIRM_OPEN_POPUP: "PAGE_CONFIRM_OPEN_POPUP",
  PAGE_CONFIRM_CLEAR: "PAGE_CONFIRM_CLEAR",
  PAGE_CONFIRM_ERRORS_CLEAR: "PAGE_CONFIRM_ERRORS_CLEAR",

  PAGE_CONFIRM_RESEND_INVITE_EMAIL_REQUEST:
    "PAGE_CONFIRM_RESEND_INVITE_EMAIL_REQUEST",
  PAGE_CONFIRM_RESEND_INVITE_EMAIL_SUCCESS:
    "PAGE_CONFIRM_RESEND_INVITE_EMAIL_SUCCESS",
  PAGE_CONFIRM_RESEND_INVITE_EMAIL_FAILURE:
    "PAGE_CONFIRM_RESEND_INVITE_EMAIL_FAILURE",

  /*
  |  Contacts
  */

  PAGE_CONTACTS_SWITCH_TAB: "PAGE_CONTACTS_SWITCH_TAB",

  /*
  |  Properties
  */

  PAGE_PROPERTIES_UNITS_FILTER: "PAGE_PROPERTIES_UNITS_FILTER",

  /*
  |  Units
  */

  PAGE_UNITS_UNITS_FILTER: "PAGE_UNITS_UNITS_FILTER",
  PAGE_UNITS_SWITCH_TAB: "PAGE_UNITS_SWITCH_TAB",

  /*
  |  Go to Fiannces.charges from unit listing
  */

  SELECTED_CHARGES_FOR_PAY: "SELECTED_CHARGES_FOR_PAY",
  SELECTED_CHARGES_FOR_PAY_CLEAR: "SELECTED_CHARGES_FOR_PAY_CLEAR",

  /*
  |  Saving data before redirecting
  */

  SAVED_DATA_BEFORE_REDIRECTING: "SAVED_DATA_BEFORE_REDIRECTING",
  SAVED_DATA_BEFORE_REDIRECTING_CLEAR: "SAVED_DATA_BEFORE_REDIRECTING_CLEAR",
  PROPERTY_SAVED_DATA_BEFORE_REDIRECTING_CLEAR:
    "PROPERTY_SAVED_DATA_BEFORE_REDIRECTING_CLEAR",
  UNIT_SAVED_DATA_BEFORE_REDIRECTING_CLEAR:
    "UNIT_SAVED_DATA_BEFORE_REDIRECTING_CLEAR",

  /*
  |  Saving data before redirecting
  */

  UPDATE_BREADCRUMBS: "UPDATE_BREADCRUMBS",
  BREADCRUMBS_CLEAR: "BREADCRUMBS_CLEAR",

  /*
  |  Person create
  */

  PERSON_CREATE_PAGE_TEMPLATE: "PERSON_CREATE_PAGE_TEMPLATE",
  PERSON_CREATE_PAGE_TEMPLATE_CLEAR: "PERSON_CREATE_PAGE_TEMPLATE_CLEAR",

  /*
  |  Company create
  */

  COMPANY_CREATE_PAGE_TEMPLATE: "COMPANY_CREATE_PAGE_TEMPLATE",
  COMPANY_CREATE_PAGE_TEMPLATE_CLEAR: "COMPANY_CREATE_PAGE_TEMPLATE_CLEAR",

  /*
  |  Redirect path
  */

  REDIRECT_PATH: "REDIRECT_PATH",
  REDIRECT_PATH_CLEAR: "REDIRECT_PATH_CLEAR",

  /*
  |  Saving data before redirecting
  */

  POST_PROCESS_MESSAGE: "POST_PROCESS_MESSAGE",
  POST_PROCESS_MESSAGE_CLEAR: "POST_PROCESS_MESSAGE_CLEAR",

  /*
  |  Person Create
  */

  PAGE_CONTACT_PERSON_CREATE_START: "PAGE_CONTACT_PERSON_CREATE_START",
  PAGE_CONTACT_PERSON_CREATE_REQUEST: "PAGE_CONTACT_PERSON_CREATE_REQUEST",
  PAGE_CONTACT_PERSON_CREATE_SUCCESS: "PAGE_CONTACT_PERSON_CREATE_SUCCESS",
  PAGE_CONTACT_PERSON_CREATE_FAILURE: "PAGE_CONTACT_PERSON_CREATE_FAILURE",
  PAGE_CONTACT_PERSON_CREATE_CLEAR: "PAGE_CONTACT_PERSON_CREATE_CLEAR",

  /*
  |  Person Update
  */

  PAGE_CONTACT_PERSON_UPDATE_START: "PAGE_CONTACT_PERSON_UPDATE_START",
  PAGE_CONTACT_PERSON_UPDATE_REQUEST: "PAGE_CONTACT_PERSON_UPDATE_REQUEST",
  PAGE_CONTACT_PERSON_UPDATE_SUCCESS: "PAGE_CONTACT_PERSON_UPDATE_SUCCESS",
  PAGE_CONTACT_PERSON_UPDATE_FAILURE: "PAGE_CONTACT_PERSON_UPDATE_FAILURE",
  PAGE_CONTACT_PERSON_UPDATE_CLEAR: "PAGE_CONTACT_PERSON_UPDATE_CLEAR",
  OPEN_PERSON_UPDATE_BY_DEFAULT: "OPEN_PERSON_UPDATE_BY_DEFAULT",

  /*
  |  Person Update
  */

  CHECK_PHONE_NUMBER_START: "CHECK_PHONE_NUMBER_START",
  CHECK_PHONE_NUMBER_REQUEST: "CHECK_PHONE_NUMBER_REQUEST",
  CHECK_PHONE_NUMBER_SUCCESS: "CHECK_PHONE_NUMBER_SUCCESS",
  CHECK_PHONE_NUMBER_FAILURE: "CHECK_PHONE_NUMBER_FAILURE",

  /*
  |  Company Create
  */

  PAGE_CONTACT_COMPANY_CREATE_START: "PAGE_CONTACT_COMPANY_CREATE_START",
  PAGE_CONTACT_COMPANY_CREATE_REQUEST: "PAGE_CONTACT_COMPANY_CREATE_REQUEST",
  PAGE_CONTACT_COMPANY_CREATE_SUCCESS: "PAGE_CONTACT_COMPANY_CREATE_SUCCESS",
  PAGE_CONTACT_COMPANY_CREATE_FAILURE: "PAGE_CONTACT_COMPANY_CREATE_FAILURE",
  PAGE_CONTACT_COMPANY_CREATE_CLEAR: "PAGE_CONTACT_COMPANY_CREATE_CLEAR",

  /*
  |  Company Update
  */

  PAGE_CONTACT_COMPANY_UPDATE_START: "PAGE_CONTACT_COMPANY_UPDATE_START",
  PAGE_CONTACT_COMPANY_UPDATE_REQUEST: "PAGE_CONTACT_COMPANY_UPDATE_REQUEST",
  PAGE_CONTACT_COMPANY_UPDATE_SUCCESS: "PAGE_CONTACT_COMPANY_UPDATE_SUCCESS",
  PAGE_CONTACT_COMPANY_UPDATE_FAILURE: "PAGE_CONTACT_COMPANY_UPDATE_FAILURE",
  PAGE_CONTACT_COMPANY_UPDATE_CLEAR: "PAGE_CONTACT_COMPANY_UPDATE_CLEAR",
  PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB:
    "PAGE_CONTACT_COMPANY_UPDATE_SWITCH_TAB",

  COMPANY_DETAILS_OVERVIEW_TAB: "COMPANY_DETAILS_OVERVIEW_TAB",
  COMPANY_DETAILS_CHARGES_TAB: "COMPANY_DETAILS_CHARGES_TAB",
  COMPANY_DETAILS_INVOICES_TAB: "COMPANY_DETAILS_INVOICES_TAB",
  COMPANY_DETAILS_STATEMENTS_TAB: "COMPANY_DETAILS_STATEMENTS_TAB",
  COMPANY_DETAILS_SAVINGS_TAB: "COMPANY_DETAILS_SAVINGS_TAB",
  COMPANY_DETAILS_SETTINGS_TAB: "COMPANY_DETAILS_SETTINGS_TAB",

  /*
  |  Contract Update
  */

  PAGE_CONTRACT_UPDATE_START: "PAGE_CONTRACT_UPDATE_START",
  PAGE_CONTRACT_UPDATE_REQUEST: "PAGE_CONTRACT_UPDATE_REQUEST",
  PAGE_CONTRACT_UPDATE_SUCCESS: "PAGE_CONTRACT_UPDATE_SUCCESS",
  PAGE_CONTRACT_UPDATE_FAILURE: "PAGE_CONTRACT_UPDATE_FAILURE",
  PAGE_CONTRACT_UPDATE_CLEAR: "PAGE_CONTRACT_UPDATE_CLEAR",
  PAGE_CONTRACT_UPDATE_ERRORS_CLEAR: "PAGE_CONTRACT_UPDATE_ERRORS_CLEAR",

  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_START:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_START",
  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_REQUEST:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_REQUEST",
  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_SUCCESS:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_SUCCESS",
  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_FAILURE:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_FAILURE",

  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_START:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_START",
  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_REQUEST:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_REQUEST",
  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_SUCCESS:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_SUCCESS",
  GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_FAILURE:
    "GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_FAILURE",

  COLLECTIVE_INVOICE_CREATE_START: "COLLECTIVE_INVOICE_CREATE_START",
  COLLECTIVE_INVOICE_CREATE_REQUEST: "COLLECTIVE_INVOICE_CREATE_REQUEST",
  COLLECTIVE_INVOICE_CREATE_SUCCESS: "COLLECTIVE_INVOICE_CREATE_SUCCESS",
  COLLECTIVE_INVOICE_CREATE_FAILURE: "COLLECTIVE_INVOICE_CREATE_FAILURE",
  COLLECTIVE_INVOICE_CREATE_CLEAR: "COLLECTIVE_INVOICE_CREATE_CLEAR",

  CONTRACT_PDF_CREATE_START: "CONTRACT_PDF_CREATE_START",
  CONTRACT_PDF_CREATE_REQUEST: "CONTRACT_PDF_CREATE_REQUEST",
  CONTRACT_PDF_CREATE_SUCCESS: "CONTRACT_PDF_CREATE_SUCCESS",
  CONTRACT_PDF_CREATE_FAILURE: "CONTRACT_PDF_CREATE_FAILURE",
  CONTRACT_PDF_CREATE_CLEAR: "CONTRACT_PDF_CREATE_CLEAR",

  GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_START:
    "GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_START",
  GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_REQUEST:
    "GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_REQUEST",
  GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_SUCCESS:
    "GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_SUCCESS",
  GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_FAILURE:
    "GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_FAILURE",

  PAGE_CONTRACT_UPDATE_HAS_CHARGES_CHANGES:
    "PAGE_CONTRACT_UPDATE_HAS_CHARGES_CHANGES",

  /*
  |  IsReadonly
  */

  GLOBAL_IS_READONLY_START: "GLOBAL_IS_READONLY_START",
  GLOBAL_IS_READONLY_REQUEST: "GLOBAL_IS_READONLY_REQUEST",
  GLOBAL_IS_READONLY_SUCCESS: "GLOBAL_IS_READONLY_SUCCESS",
  GLOBAL_IS_READONLY_FAILURE: "GLOBAL_IS_READONLY_FAILURE",

  /*
  |  Contract Create
  */

  PERSON_ID_FOR_CREATING_CONTRACT: "PERSON_ID_FOR_CREATING_CONTRACT",
  PAGE_CONTRACT_CREATE_PUT_CHARGE_TEMPLATES_TO_MEMORY:
    "PAGE_CONTRACT_CREATE_PUT_CHARGE_TEMPLATES_TO_MEMORY",

  /*
  |  Charge Create
  */

  PAGE_CHARGE_CREATE_ADD_PARAMS: "PAGE_CHARGE_CREATE_ADD_PARAMS",

  /*
  |  Task Create
  */

  PAGE_TASK_CREATE_ADD_PARAMS: "PAGE_TASK_CREATE_ADD_PARAMS",

  /*
  |  Activity Create
  */

  PAGE_ACTIVITY_CREATE_ADD_PARAMS: "PAGE_ACTIVITY_CREATE_ADD_PARAMS",

  /*
  |  Property Update
  */

  PAGE_PROPERTY_UPDATE_START: "PAGE_PROPERTY_UPDATE_START",
  PAGE_PROPERTY_UPDATE_REQUEST: "PAGE_PROPERTY_UPDATE_REQUEST",
  PAGE_PROPERTY_UPDATE_SUCCESS: "PAGE_PROPERTY_UPDATE_SUCCESS",
  PAGE_PROPERTY_UPDATE_FAILURE: "PAGE_PROPERTY_UPDATE_FAILURE",
  PAGE_PROPERTY_UPDATE_CLEAR: "PAGE_PROPERTY_UPDATE_CLEAR",

  /*
  |  Property Create
  */

  PAGE_PROPERTY_CREATE_START: "PAGE_PROPERTY_CREATE_START",
  PAGE_PROPERTY_CREATE_REQUEST: "PAGE_PROPERTY_CREATE_REQUEST",
  PAGE_PROPERTY_CREATE_SUCCESS: "PAGE_PROPERTY_CREATE_SUCCESS",
  PAGE_PROPERTY_CREATE_FAILURE: "PAGE_PROPERTY_CREATE_FAILURE",
  PAGE_PROPERTY_CREATE_CLEAR: "PAGE_PROPERTY_CREATE_CLEAR",

  PAGE_PROPERTY_CREATE_ADD_PARAMS: "PAGE_PROPERTY_CREATE_ADD_PARAMS",


  /*
  |  Create Table
  */
  GLOBAL_CHARGES_DOWNLOAD_START: 'GLOBAL_CHARGES_DOWNLOAD_START',
  GLOBAL_CHARGES_DOWNLOAD_SUCCESS: 'GLOBAL_CHARGES_DOWNLOAD_SUCCESS',
  GLOBAL_CHARGES_DOWNLOAD_FAILURE: 'GLOBAL_CHARGES_DOWNLOAD_FAILURE',

  /*
  |  Property Delete
  */

  PAGE_PROPERTY_DELETE_START: "PAGE_PROPERTY_DELETEE_START",
  PAGE_PROPERTY_DELETE_REQUEST: "PAGE_PROPERTY_DELETE_REQUEST",
  PAGE_PROPERTY_DELETE_SUCCESS: "PAGE_PROPERTY_DELETE_SUCCESS",
  PAGE_PROPERTY_DELETE_FAILURE: "PAGE_PROPERTY_DELETE_FAILURE",

  /*
  |  Bank Transactions
  */

  PAGE_BANK_TRANSACTIONS_PROGRESS: "PAGE_BANK_TRANSACTIONS_PROGRESS",
  PAGE_BANK_TRANSACTIONS_CLEAR: "PAGE_BANK_TRANSACTIONS_CLEAR",
  PAGE_BANK_TRANSACTIONS_SET_TITLE: "PAGE_BANK_TRANSACTIONS_SET_TITLE",
  PAGE_BANK_TRANSACTIONS_OPEN_DIALOG: "PAGE_BANK_TRANSACTIONS_OPEN_DIALOG",
  PAGE_BANK_TRANSACTIONS_CLOSE_DIALOG: "PAGE_BANK_TRANSACTIONS_CLOSE_DIALOG",
  BANK_TRANSACTION_SHOW_PAYMENTS_LIST: "BANK_TRANSACTION_SHOW_PAYMENTS_LIST",

  /*
  |  Lookup Components
  */

  LOOKUP_COMPONENT_COMPANY_CREATE_START:
    "LOOKUP_COMPONENT_COMPANY_CREATE_START",
  LOOKUP_COMPONENT_COMPANY_CREATE_REQUEST:
    "LOOKUP_COMPONENT_COMPANY_CREATE_REQUEST",
  LOOKUP_COMPONENT_COMPANY_CREATE_SUCCESS:
    "LOOKUP_COMPONENT_COMPANY_CREATE_SUCCESS",
  LOOKUP_COMPONENT_COMPANY_CREATE_FAILURE:
    "LOOKUP_COMPONENT_COMPANY_CREATE_FAILURE",

  LOOKUP_COMPONENT_PERSON_CREATE_START: "LOOKUP_COMPONENT_PERSON_CREATE_START",
  LOOKUP_COMPONENT_PERSON_CREATE_REQUEST:
    "LOOKUP_COMPONENT_PERSON_CREATE_REQUEST",
  LOOKUP_COMPONENT_PERSON_CREATE_SUCCESS:
    "LOOKUP_COMPONENT_PERSON_CREATE_SUCCESS",
  LOOKUP_COMPONENT_PERSON_CREATE_FAILURE:
    "LOOKUP_COMPONENT_PERSON_CREATE_FAILURE",

  LOOKUP_COMPONENT_CONTRACT_CREATE_START:
    "LOOKUP_COMPONENT_CONTRACT_CREATE_START",
  LOOKUP_COMPONENT_CONTRACT_CREATE_REQUEST:
    "LOOKUP_COMPONENT_CONTRACT_CREATE_REQUEST",
  LOOKUP_COMPONENT_CONTRACT_CREATE_SUCCESS:
    "LOOKUP_COMPONENT_CONTRACT_CREATE_SUCCESS",
  LOOKUP_COMPONENT_CONTRACT_CREATE_FAILURE:
    "LOOKUP_COMPONENT_CONTRACT_CREATE_FAILURE",

  LOOKUP_COMPONENT_UNIT_CREATE_START: "LOOKUP_COMPONENT_UNIT_CREATE_START",
  LOOKUP_COMPONENT_UNIT_CREATE_REQUEST: "LOOKUP_COMPONENT_UNIT_CREATE_REQUEST",
  LOOKUP_COMPONENT_UNIT_CREATE_SUCCESS: "LOOKUP_COMPONENT_UNIT_CREATE_SUCCESS",
  LOOKUP_COMPONENT_UNIT_CREATE_FAILURE: "LOOKUP_COMPONENT_UNIT_CREATE_FAILURE",

  LOOKUP_COMPONENT_PROPERTY_CREATE_START:
    "LOOKUP_COMPONENT_PROPERTY_CREATE_START",
  LOOKUP_COMPONENT_PROPERTY_CREATE_REQUEST:
    "LOOKUP_COMPONENT_PROPERTY_CREATE_REQUEST",
  LOOKUP_COMPONENT_PROPERTY_CREATE_SUCCESS:
    "LOOKUP_COMPONENT_PROPERTY_CREATE_SUCCESS",
  LOOKUP_COMPONENT_PROPERTY_CREATE_FAILURE:
    "LOOKUP_COMPONENT_PROPERTY_CREATE_FAILURE",

  LOOKUP_COMPONENT_DIALOG_TYPE_SMALL: "LOOKUP_COMPONENT_DIALOG_TYPE_SMALL",
  LOOKUP_COMPONENT_DIALOG_TYPE_MEDIUM: "LOOKUP_COMPONENT_DIALOG_TYPE_MEDIUM",
  LOOKUP_COMPONENT_DIALOG_TYPE_BIG: "LOOKUP_COMPONENT_DIALOG_TYPE_BIG",

  /*
  |  Finance
  */

  PAGE_FINANCE_UPDATE_SWITCH_TAB: "PAGE_FINANCE_UPDATE_SWITCH_TAB",

  /*
  |  Financial Statements
  */

  GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST:
    "GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST",
  GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST_SUCCESS:
    "GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST_SUCCESS",
  GLOBAL_FINANCIAL_STATEMENTS_NOT_SAVE_LIST:
    "GLOBAL_FINANCIAL_STATEMENTS_NOT_SAVE_LIST",
  GLOBAL_FINANCIAL_STATEMENTS_NOT_SAVE_LIST_SUCCESS:
    "GLOBAL_FINANCIAL_STATEMENTS_NOT_SAVE_LIST_SUCCESS",
  GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS:
    "GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS",

  PAGE_FINANCIAL_STATEMENT_DOWNLOAD_START:
    "PAGE_FINANCIAL_STATEMENT_DOWNLOAD_START",
  PAGE_FINANCIAL_STATEMENT_DOWNLOAD_REQUEST:
    "PAGE_FINANCIAL_STATEMENT_DOWNLOAD_REQUEST",
  PAGE_FINANCIAL_STATEMENT_DOWNLOAD_SUCCESS:
    "PAGE_FINANCIAL_STATEMENT_DOWNLOAD_SUCCESS",
  PAGE_FINANCIAL_STATEMENT_DOWNLOAD_FAILURE:
    "PAGE_FINANCIAL_STATEMENT_DOWNLOAD_FAILURE",

  GLOBAL_FINANCIAL_STATEMENT_DATA_START:
    "GLOBAL_FINANCIAL_STATEMENT_DATA_START",
  GLOBAL_FINANCIAL_STATEMENT_DATA_SUCCESS:
    "GLOBAL_FINANCIAL_STATEMENT_DATA_SUCCESS",

  PAGE_FINANCIAL_STATEMENT_LOCK_START: "PAGE_FINANCIAL_STATEMENT_LOCK_START",
  PAGE_FINANCIAL_STATEMENT_LOCK_REQUEST:
    "PAGE_FINANCIAL_STATEMENT_LOCK_REQUEST",
  PAGE_FINANCIAL_STATEMENT_LOCK_SUCCESS:
    "PAGE_FINANCIAL_STATEMENT_LOCK_SUCCESS",
  PAGE_FINANCIAL_STATEMENT_LOCK_FAILURE:
    "PAGE_FINANCIAL_STATEMENT_LOCK_FAILURE",

  PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_START:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_START",
  PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_REQUEST:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_REQUEST",
  PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_SUCCESS:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_SUCCESS",
  PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_FAILURE:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_FAILURE",

  PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_START:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_START",
  PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_REQUEST:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_REQUEST",
  PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_SUCCESS:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_SUCCESS",
  PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_FAILURE:
    "PAGE_FINANCIAL_STATEMENT_CHANGE_READINESS_STATUS_FAILURE",

  FINANCE_OWNER_STATEMENTS_FILTER_SEARCH_UPDATE_STATE:
    "FINANCE_OWNER_STATEMENTS_FILTER_SEARCH_UPDATE_STATE",

  GLOBAL_STATEMENT_SNOOZE_UPDATE_START: "GLOBAL_STATEMENT_SNOOZE_UPDATE_START",
  GLOBAL_STATEMENT_SNOOZE_UPDATE_REQUEST:
    "GLOBAL_STATEMENT_SNOOZE_UPDATE_REQUEST",
  GLOBAL_STATEMENT_SNOOZE_UPDATE_SUCCESS:
    "GLOBAL_STATEMENT_SNOOZE_UPDATE_SUCCESS",
  GLOBAL_STATEMENT_SNOOZE_UPDATE_FAILURE:
    "GLOBAL_STATEMENT_SNOOZE_UPDATE_FAILURE",

  FINANCE_STATEMENTS_LIST_POSITION_SAVE:
    "FINANCE_STATEMENTS_LIST_POSITION_SAVE",

  FINANCIAL_STATEMENT_UPDATE_SUCCESS: "FINANCIAL_STATEMENT_UPDATE_SUCCESS",

  /*
  |  Reports
  */

  GLOBAL_REPORT_DOWNLOAD_START: "GLOBAL_REPORT_DOWNLOAD_START",
  GLOBAL_REPORT_DOWNLOAD_REQUEST: "GLOBAL_REPORT_DOWNLOAD_REQUEST",
  GLOBAL_REPORT_DOWNLOAD_SUCCESS: "GLOBAL_REPORT_DOWNLOAD_SUCCESS",
  GLOBAL_REPORT_DOWNLOAD_FAILURE: "GLOBAL_REPORT_DOWNLOAD_FAILURE",

  /*
  |  Activities
  */

  GLOBAL_ACTIVITY_TEMPLATE_LIST: "GLOBAL_ACTIVITY_TEMPLATE_LIST",
  GLOBAL_ACTIVITY_TEMPLATE_LIST_SUCCESS:
    "GLOBAL_ACTIVITY_TEMPLATE_LIST_SUCCESS",

  GLOBAL_ACTIVITY_TEMPLATE_CREATE_START:
    "GLOBAL_ACTIVITY_TEMPLATE_CREATE_START",
  GLOBAL_ACTIVITY_TEMPLATE_CREATE_REQUEST:
    "GLOBAL_ACTIVITY_TEMPLATE_CREATE_REQUEST",
  GLOBAL_ACTIVITY_TEMPLATE_CREATE_SUCCESS:
    "GLOBAL_ACTIVITY_TEMPLATE_CREATE_SUCCESS",
  GLOBAL_ACTIVITY_TEMPLATE_CREATE_FAILURE:
    "GLOBAL_ACTIVITY_TEMPLATE_CREATE_FAILURE",
  GLOBAL_ACTIVITY_TEMPLATE_CREATE_CLEAR:
    "GLOBAL_ACTIVITY_TEMPLATE_CREATE_CLEAR",

  GLOBAL_ACTIVITY_TEMPLATE_UPDATE_START:
    "GLOBAL_ACTIVITY_TEMPLATE_UPDATE_START",
  GLOBAL_ACTIVITY_TEMPLATE_UPDATE_REQUEST:
    "GLOBAL_ACTIVITY_TEMPLATE_UPDATE_REQUEST",
  GLOBAL_ACTIVITY_TEMPLATE_UPDATE_SUCCESS:
    "GLOBAL_ACTIVITY_TEMPLATE_UPDATE_SUCCESS",
  GLOBAL_ACTIVITY_TEMPLATE_UPDATE_FAILURE:
    "GLOBAL_ACTIVITY_TEMPLATE_UPDATE_FAILURE",
  GLOBAL_ACTIVITY_TEMPLATE_UPDATE_CLEAR:
    "GLOBAL_ACTIVITY_TEMPLATE_UPDATE_CLEAR",

  GLOBAL_ACTIVITY_TEMPLATE_DELETE_START:
    "GLOBAL_ACTIVITY_TEMPLATE_DELETE_START",
  GLOBAL_ACTIVITY_TEMPLATE_DELETE_REQUEST:
    "GLOBAL_ACTIVITY_TEMPLATE_DELETE_REQUEST",
  GLOBAL_ACTIVITY_TEMPLATE_DELETE_SUCCESS:
    "GLOBAL_ACTIVITY_TEMPLATE_DELETE_SUCCESS",
  GLOBAL_ACTIVITY_TEMPLATE_DELETE_FAILURE:
    "GLOBAL_ACTIVITY_TEMPLATE_DELETE_FAILURE",
  GLOBAL_ACTIVITY_TEMPLATE_DELETE_CLEAR:
    "GLOBAL_ACTIVITY_TEMPLATE_DELETE_CLEAR",

  GLOBAL_ACTIVITY_CREATE_START: "GLOBAL_ACTIVITY_CREATE_START",
  GLOBAL_ACTIVITY_CREATE_REQUEST: "GLOBAL_ACTIVITY_CREATE_REQUEST",
  GLOBAL_ACTIVITY_CREATE_SUCCESS: "GLOBAL_ACTIVITY_CREATE_SUCCESS",
  GLOBAL_ACTIVITY_CREATE_FAILURE: "GLOBAL_ACTIVITY_CREATE_FAILURE",
  GLOBAL_ACTIVITY_CREATE_CLEAR: "GLOBAL_ACTIVITY_CREATE_CLEAR",

  GLOBAL_ACTIVITY_UPDATE_START: "GLOBAL_ACTIVITY_UPDATE_START",
  GLOBAL_ACTIVITY_UPDATE_REQUEST: "GLOBAL_ACTIVITY_UPDATE_REQUEST",
  GLOBAL_ACTIVITY_UPDATE_SUCCESS: "GLOBAL_ACTIVITY_UPDATE_SUCCESS",
  GLOBAL_ACTIVITY_UPDATE_FAILURE: "GLOBAL_ACTIVITY_UPDATE_FAILURE",
  GLOBAL_ACTIVITY_UPDATE_CLEAR: "GLOBAL_ACTIVITY_UPDATE_CLEAR",

  PAGE_ACTIVITY_TEMPLATE_CREATE_PUT_TASK_TEMPLATES_TO_MEMORY:
    "PAGE_ACTIVITY_TEMPLATE_CREATE_PUT_TASK_TEMPLATES_TO_MEMORY",

  /*
  |  Task Templates
  */

  GLOBAL_TASK_TEMPLATE_LIST: "GLOBAL_TASK_TEMPLATE_LIST",
  GLOBAL_TASK_TEMPLATE_LIST_SUCCESS: "GLOBAL_TASK_TEMPLATE_LIST_SUCCESS",

  GLOBAL_TASK_TEMPLATE_CREATE_START: "GLOBAL_TASK_TEMPLATE_CREATE_START",
  GLOBAL_TASK_TEMPLATE_CREATE_REQUEST: "GLOBAL_TASK_TEMPLATE_CREATE_REQUEST",
  GLOBAL_TASK_TEMPLATE_CREATE_SUCCESS: "GLOBAL_TASK_TEMPLATE_CREATE_SUCCESS",
  GLOBAL_TASK_TEMPLATE_CREATE_FAILURE: "GLOBAL_TASK_TEMPLATE_CREATE_FAILURE",
  GLOBAL_TASK_TEMPLATE_CREATE_CLEAR: "GLOBAL_TASK_TEMPLATE_CREATE_CLEAR",

  GLOBAL_TASK_TEMPLATE_UPDATE_START: "GLOBAL_TASK_TEMPLATE_UPDATE_START",
  GLOBAL_TASK_TEMPLATE_UPDATE_REQUEST: "GLOBAL_TASK_TEMPLATE_UPDATE_REQUEST",
  GLOBAL_TASK_TEMPLATE_UPDATE_SUCCESS: "GLOBAL_TASK_TEMPLATE_UPDATE_SUCCESS",
  GLOBAL_TASK_TEMPLATE_UPDATE_FAILURE: "GLOBAL_TASK_TEMPLATE_UPDATE_FAILURE",
  GLOBAL_TASK_TEMPLATE_UPDATE_CLEAR: "GLOBAL_TASK_TEMPLATE_UPDATE_CLEAR",

  GLOBAL_TASK_TEMPLATE_DELETE_START: "GLOBAL_TASK_TEMPLATE_DELETE_START",
  GLOBAL_TASK_TEMPLATE_DELETE_REQUEST: "GLOBAL_TASK_TEMPLATE_DELETE_REQUEST",
  GLOBAL_TASK_TEMPLATE_DELETE_SUCCESS: "GLOBAL_TASK_TEMPLATE_DELETE_SUCCESS",
  GLOBAL_TASK_TEMPLATE_DELETE_FAILURE: "GLOBAL_TASK_TEMPLATE_DELETE_FAILURE",

  /*
  |  Task
  */

  PAGE_TASKS_LIST_CHECK_FILTER: "PAGE_TASKS_LIST_CHECK_FILTER",

  TASK_FILTER_SEARCH_UPDATE_STATE: "TASK_FILTER_SEARCH_UPDATE_STATE",

  GLOBAL_UNFINISHED_TASKS_COUNT: "GLOBAL_UNFINISHED_TASKS_COUNT",
  GLOBAL_UNFINISHED_TASKS_COUNT_SUCCESS:
    "GLOBAL_UNFINISHED_TASKS_COUNT_SUCCESS",

  NOTES_FILTER_UPDATE_STATE: "NOTES_FILTER_UPDATE_STATE",
  NOTES_FILTER_SEARCH_UPDATE_STATE: "NOTES_FILTER_SEARCH_UPDATE_STATE",

  NOTIFICATIONS_FILTER_UPDATE_STATE: "NOTIFICATIONS_FILTER_UPDATE_STATE",
  NOTIFICATIONS_FILTER_SEARCH_UPDATE_STATE:
    "NOTIFICATIONS_FILTER_SEARCH_UPDATE_STATE",

  ACTIVITIES_FILTER_UPDATE_STATE: "ACTIVITIES_FILTER_UPDATE_STATE",
  ACTIVITIES_FILTER_SEARCH_UPDATE_STATE:
    "ACTIVITIES_FILTER_SEARCH_UPDATE_STATE",

  /*
  |  Note
  */

  GLOBAL_NOTE_CREATE_START: "GLOBAL_NOTE_CREATE_START",
  GLOBAL_NOTE_CREATE_REQUEST: "GLOBAL_NOTE_CREATE_REQUEST",
  GLOBAL_NOTE_CREATE_SUCCESS: "GLOBAL_NOTE_CREATE_SUCCESS",
  GLOBAL_NOTE_CREATE_FAILURE: "GLOBAL_NOTE_CREATE_FAILURE",
  GLOBAL_NOTE_CREATE_CLEAR: "GLOBAL_NOTE_CREATE_CLEAR",

  GLOBAL_NOTE_UPDATE_START: "GLOBAL_NOTE_UPDATE_START",
  GLOBAL_NOTE_UPDATE_REQUEST: "GLOBAL_NOTE_UPDATE_REQUEST",
  GLOBAL_NOTE_UPDATE_SUCCESS: "GLOBAL_NOTE_UPDATE_SUCCESS",
  GLOBAL_NOTE_UPDATE_FAILURE: "GLOBAL_NOTE_UPDATE_FAILURE",
  GLOBAL_NOTE_UPDATE_CLEAR: "GLOBAL_NOTE_UPDATE_CLEAR",

  /*
  |  Bank Accounts
  */

  GLOBAL_BANK_ACCOUNT_LIST: "GLOBAL_BANK_ACCOUNT_LIST",
  GLOBAL_BANK_ACCOUNT_LIST_SUCCESS: "GLOBAL_BANK_ACCOUNT_LIST_SUCCESS",

  GLOBAL_BANK_ACCOUNT_CREATE_START: "GLOBAL_BANK_ACCOUNT_CREATE_START",
  GLOBAL_BANK_ACCOUNT_CREATE_REQUEST: "GLOBAL_BANK_ACCOUNT_CREATE_REQUEST",
  GLOBAL_BANK_ACCOUNT_CREATE_SUCCESS: "GLOBAL_BANK_ACCOUNT_CREATE_SUCCESS",
  GLOBAL_BANK_ACCOUNT_CREATE_FAILURE: "GLOBAL_BANK_ACCOUNT_CREATE_FAILURE",
  GLOBAL_BANK_ACCOUNT_CREATE_CLEAR: "GLOBAL_BANK_ACCOUNT_CREATE_CLEAR",

  GLOBAL_BANK_ACCOUNT_UPDATE_START: "GLOBAL_BANK_ACCOUNT_UPDATE_START",
  GLOBAL_BANK_ACCOUNT_UPDATE_REQUEST: "GLOBAL_BANK_ACCOUNT_UPDATE_REQUEST",
  GLOBAL_BANK_ACCOUNT_UPDATE_SUCCESS: "GLOBAL_BANK_ACCOUNT_UPDATE_SUCCESS",
  GLOBAL_BANK_ACCOUNT_UPDATE_FAILURE: "GLOBAL_BANK_ACCOUNT_UPDATE_FAILURE",
  GLOBAL_BANK_ACCOUNT_UPDATE_CLEAR: "GLOBAL_BANK_ACCOUNT_UPDATE_CLEAR",

  GLOBAL_BANK_ACCOUNT_DELETE_START: "GLOBAL_BANK_ACCOUNT_DELETE_START",
  GLOBAL_BANK_ACCOUNT_DELETE_REQUEST: "GLOBAL_BANK_ACCOUNT_DELETE_REQUEST",
  GLOBAL_BANK_ACCOUNT_DELETE_SUCCESS: "GLOBAL_BANK_ACCOUNT_DELETE_SUCCESS",
  GLOBAL_BANK_ACCOUNT_DELETE_FAILURE: "GLOBAL_BANK_ACCOUNT_DELETE_FAILURE",

  /*
  |  Ponto Integration
  */
  GLOBAL_PONTO_REVOKE_ACCESS: "GLOBAL_PONTO_REVOKE_ACCESS",
  GLOBAL_PONTO_SYNCHRONIZE: "GLOBAL_PONTO_SYNCHRONIZE",
  GLOBAL_PONTO_INTEGRATION_GET: "GLOBAL_PONTO_INTEGRATION_GET",
  GLOBAL_PONTO_INTEGRATION_GET_SUCCESS: "GLOBAL_PONTO_INTEGRATION_GET_SUCCESS",
  PONTO_AUTHORIZATION_UPDATE: "PONTO_AUTHORIZATION_UPDATE",
  PONTO_AUTHORIZATION_REQUIRED: "PONTO_AUTHORIZATION_REQUIRED",
  PONTO_AUTHORIZATION_IN_PROGRESS: "PONTO_AUTHORIZATION_IN_PROGRESS",
  PONTO_SYNC_ERROR: "PONTO_SYNC_ERROR",
  PONTO_REVOKE_ERROR: "PONTO_REVOKE_ERROR",

  /*
  Data types
  */
  GLOBAL_RECEIVE_DATA_TYPES_LIST: "GLOBAL_RECEIVE_DATA_TYPES_LIST",
  GLOBAL_RECEIVE_DATA_TYPES_LIST_SUCCESS:
    "GLOBAL_RECEIVE_DATA_TYPES_LIST_SUCCESS",

  /*
  |  Email Send
  */

  GLOBAL_EMAIL_SEND_START: "GLOBAL_EMAIL_SEND_START",
  GLOBAL_EMAIL_SEND_REQUEST: "GLOBAL_EMAIL_SEND_REQUEST",
  GLOBAL_EMAIL_SEND_SUCCESS: "GLOBAL_EMAIL_SEND_SUCCESS",
  GLOBAL_EMAIL_SEND_FAILURE: "GLOBAL_EMAIL_SEND_FAILURE",
  GLOBAL_EMAIL_SEND_CLEAR: "GLOBAL_EMAIL_SEND_CLEAR",

  GLOBAL_LINK_SEND_START: "GLOBAL_LINK_SEND_START",
  GLOBAL_LINK_SEND_REQUEST: "GLOBAL_LINK_SEND_REQUEST",
  GLOBAL_LINK_SEND_SUCCESS: "GLOBAL_LINK_SEND_SUCCESS",
  GLOBAL_LINK_SEND_FAILURE: "GLOBAL_LINK_SEND_FAILURE",
  GLOBAL_LINK_SEND_CLEAR: "GLOBAL_LINK_SEND_CLEAR",

  GET_LOGIN_PORTAL_LINK_START: "GET_LOGIN_PORTAL_LINK_START",
  GET_LOGIN_PORTAL_LINK_REQUEST: "GET_LOGIN_PORTAL_LINK_REQUEST",
  GET_LOGIN_PORTAL_LINK_SUCCESS: "GET_LOGIN_PORTAL_LINK_SUCCESS",
  GET_LOGIN_PORTAL_LINK_FAILURE: "GET_LOGIN_PORTAL_LINK_FAILURE",
  GET_LOGIN_PORTAL_LINK_CLEAR: "GET_LOGIN_PORTAL_LINK_CLEAR",

  /*
  |  Pay Charge
  */

  GLOBAL_PAY_CHARGES_START: "GLOBAL_PAY_CHARGES_START",
  GLOBAL_PAY_CHARGES_REQUEST: "GLOBAL_PAY_CHARGES_REQUEST",
  GLOBAL_PAY_CHARGES_SUCCESS: "GLOBAL_PAY_CHARGES_SUCCESS",
  GLOBAL_PAY_CHARGES_FAILURE: "GLOBAL_PAY_CHARGES_FAILURE",
  GLOBAL_PAY_CHARGES_CLEAR: "GLOBAL_PAY_CHARGES_CLEAR",

  /*
  |  Launch panel
  */
  GLOBAL_LAUNCH_PANEL_STATE: "GLOBAL_LAUNCH_PANEL_STATE",

  /*
  |  Conversation
  */

  GLOBAL_CONVERSATIONS_SAVE_LIST: "GLOBAL_CONVERSATIONS_SAVE_LIST",
  GLOBAL_CONVERSATIONS_SAVE_LIST_SUCCESS:
    "GLOBAL_CONVERSATIONS_SAVE_LIST_SUCCESS",
  GLOBAL_CONVERSATIONS_NOT_SAVE_LIST: "GLOBAL_CONVERSATIONS_NOT_SAVE_LIST",
  GLOBAL_CONVERSATIONS_NOT_SAVE_LIST_SUCCESS:
    "GLOBAL_CONVERSATIONS_NOT_SAVE_LIST_SUCCESS",
  GLOBAL_CONVERSATIONS_LIST_OUTDATE_REQUESTS:
    "GLOBAL_CONVERSATIONS_LIST_OUTDATE_REQUESTS",

  GLOBAL_CONVERSATION_FOR_CONVERSATION_DETAILS_PAGE:
    "GLOBAL_CONVERSATION_FOR_CONVERSATION_DETAILS_PAGE",

  GLOBAL_CONVERSATION_CREATE_START: "GLOBAL_CONVERSATION_CREATE_START",
  GLOBAL_CONVERSATION_CREATE_REQUEST: "GLOBAL_CONVERSATION_CREATE_REQUEST",
  GLOBAL_CONVERSATION_CREATE_SUCCESS: "GLOBAL_CONVERSATION_CREATE_SUCCESS",
  GLOBAL_CONVERSATION_CREATE_FAILURE: "GLOBAL_CONVERSATION_CREATE_FAILURE",
  GLOBAL_CONVERSATION_CREATE_CLEAR: "GLOBAL_CONVERSATION_CREATE_CLEAR",

  GLOBAL_CONVERSATION_UPDATE_START: "GLOBAL_CONVERSATION_UPDATE_START",
  GLOBAL_CONVERSATION_UPDATE_REQUEST: "GLOBAL_CONVERSATION_UPDATE_REQUEST",
  GLOBAL_CONVERSATION_UPDATE_SUCCESS: "GLOBAL_CONVERSATION_UPDATE_SUCCESS",
  GLOBAL_CONVERSATION_UPDATE_FAILURE: "GLOBAL_CONVERSATION_UPDATE_FAILURE",
  GLOBAL_CONVERSATION_UPDATE_CLEAR: "GLOBAL_CONVERSATION_UPDATE_CLEAR",

  GLOBAL_CONVERSATION_STATUS_UPDATE_START:
    "GLOBAL_CONVERSATION_STATUS_UPDATE_START",
  GLOBAL_CONVERSATION_STATUS_UPDATE_REQUEST:
    "GLOBAL_CONVERSATION_STATUS_UPDATE_REQUEST",
  GLOBAL_CONVERSATION_STATUS_UPDATE_SUCCESS:
    "GLOBAL_CONVERSATION_STATUS_UPDATE_SUCCESS",
  GLOBAL_CONVERSATION_STATUS_UPDATE_FAILURE:
    "GLOBAL_CONVERSATION_STATUS_UPDATE_FAILURE",
  GLOBAL_CONVERSATION_STATUS_UPDATE_CLEAR:
    "GLOBAL_CONVERSATION_STATUS_UPDATE_CLEAR",

  GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_START:
    "GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_START",
  GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_REQUEST:
    "GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_REQUEST",
  GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_SUCCESS:
    "GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_SUCCESS",
  GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_FAILURE:
    "GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_FAILURE",
  GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_CLEAR:
    "GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_CLEAR",

  GLOBAL_CONVERSATION_READ_UPDATE_START:
    "GLOBAL_CONVERSATION_READ_UPDATE_START",
  GLOBAL_CONVERSATION_READ_UPDATE_REQUEST:
    "GLOBAL_CONVERSATION_READ_UPDATE_REQUEST",
  GLOBAL_CONVERSATION_READ_UPDATE_SUCCESS:
    "GLOBAL_CONVERSATION_READ_UPDATE_SUCCESS",
  GLOBAL_CONVERSATION_READ_UPDATE_FAILURE:
    "GLOBAL_CONVERSATION_READ_UPDATE_FAILURE",
  GLOBAL_CONVERSATION_READ_UPDATE_CLEAR:
    "GLOBAL_CONVERSATION_READ_UPDATE_CLEAR",

  GLOBAL_MESSAGE_CREATE_START: "GLOBAL_MESSAGE_CREATE_START",
  GLOBAL_MESSAGE_CREATE_REQUEST: "GLOBAL_MESSAGE_CREATE_REQUEST",
  GLOBAL_MESSAGE_CREATE_SUCCESS: "GLOBAL_MESSAGE_CREATE_SUCCESS",
  GLOBAL_MESSAGE_CREATE_FAILURE: "GLOBAL_MESSAGE_CREATE_FAILURE",
  GLOBAL_MESSAGE_CREATE_CLEAR: "GLOBAL_MESSAGE_CREATE_CLEAR",

  /*
  |  Coach new property first user
  */

  COACH_ERRORS_CLEAR: "COACH_ERRORS_CLEAR",

  SWITCH_TRANSLATION_KEYS: "SWITCH_TRANSLATION_KEYS",
  ACTIVATE_CLIENT_ACCOUNT: "ACTIVATE_CLIENT_ACCOUNT",

  /*
  |  Coach
  */
  COACH_TOGGLE: "COACH_TOGGLE",
  SET_NEW_BILL_SETTLEMENT_STATE: "SET_NEW_BILL_SETTLEMENT_STATE",

  /*
  | Process
  */
  START_PROCESS: "START_PROCESS",
};

export default Constants;
